// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { acceptInvitation, acknowledgeEvent, activateUser, approveTrialSetupRequest, assignmentTimeline, auditEvents, authFinish, authStart, autosave, batteryTrend, bulkAcknowledge, bulkImportParticipants, bulkSend, bulkValidate, changePassword, changeTrialStatus, checkMyPermissions, checkPermissions, completeEnrollment, connectionLogs, createAssignment, createCohort, createContact, createMedication, createOrganization, createParticipant, createProfile, createSite, createTrial, createTrialSetupRequest, csrfToken, deactivateUser, deleteCohort, deleteContact, deleteMedication, deleteMedicationNested, deleteOrganization, deleteParticipant, deletePasskey, deleteProfile, deleteSite, deleteTrial, deleteTrialParticipant, deleteTrialSetupRequest, deleteUser, deviceHealthSummary, disable2Fa, downloadAttachment, enable2Fa, enroll, enrollPassphrase, exportAuditLogs, exportAuditLogs2, exportAuditLogs3, exportDeliveries, exportUsers, generate2Fa, generateEnrollmentForms, getAccessibleResources, getByTrialAndSerial, getCohort, getDelivery, getDeliveryContent, getDetailed, getEnrollment, getEvent, getEventSummary, getMapsToken, getMe, getMedication, getMedicationNested, getMedicationSlots, getMedicationSlots2, getMetadata, getMetadata2, getMyAccessibleResources, getMyPermissions, getOrganization, getOrganizationBySlug, getOrganizationDashboard, getParticipant, getParticipantAdherence, getParticipantBySlug, getParticipantHealth, getPopulationAdherence, getProfile, getProfile2, getPushStatus, getSettings, getSite, getSubmission, getTrial, getTrialBySlug, getTrialLiveFeed, getTrialParticipant, getTrialSetupRequest, getUnreadCount, getUserPermissions, getUserStatistics, grantPermissions, heartbeat, listAuditLogs, listAuditLogs2, listCohorts, listContacts, listDeliveries, listDeliveryAttachments, listDispensers, listDispensersAlias, listEvents, listInvitations, listMedications, listNotifications, listOrganizations, listParticipants, listPasskeys, listPermissions, listProfiles, listSites, listTrials, listTrialSetupRequests, listUsers, login, login2Fa, logout, markAllAsRead, markAsRead, type Options, passwordRecovery, passwordReset, previewProfile, pushSend, refresh, registerFinish, registerPushToken, registerStart, rejectTrialSetupRequest, requestVerification, resetParticipantEnrollment, resetTrialEnrollment, resolveEvent, revokeInvitation, revokePermissions, sendInvitation, sendParticipantPush, sendStudyMessage, submit, submitTrialSetupRequest, syncBattery, syncBulk, syncEvents, testSendProfile, unarchiveCohort, unarchiveOrganization, unarchiveParticipant, unarchiveSite, unarchiveTrial, unassign, unenrollClient, updateCohort, updateContact, updateMedication, updateMedicationNested, updateOrganization, updateParticipant, updateProfile, updateProfile2, updateSite, updateTrial, updateTrialParticipant, updateTrialSetupRequest, upsertSettings, validateAssignments, verifyChain, verifyChain2, verifyToken, withdrawEnrollment } from '../sdk.gen';
import type { AcceptInvitationData, AcceptInvitationResponse, AcknowledgeEventData, AcknowledgeEventResponse, ActivateUserData, ActivateUserResponse, ApproveTrialSetupRequestData, ApproveTrialSetupRequestResponse, AssignmentTimelineData, AssignmentTimelineResponse, AuditEventsData, AuditEventsResponse, AuthFinishData, AuthFinishResponse, AuthStartData, AuthStartResponse2, AutosaveData, AutosaveResponse, BatteryTrendData, BatteryTrendResponse2, BulkAcknowledgeData, BulkAcknowledgeResponse2, BulkImportParticipantsData, BulkImportParticipantsResponse, BulkSendData, BulkSendResponse2, BulkValidateData, BulkValidateResponse2, ChangePasswordData, ChangePasswordResponse, ChangeTrialStatusData, ChangeTrialStatusResponse, CheckMyPermissionsData, CheckMyPermissionsResponse, CheckPermissionsData, CheckPermissionsResponse, CompleteEnrollmentData, CompleteEnrollmentResponse, ConnectionLogsData, ConnectionLogsResponse, CreateAssignmentData, CreateAssignmentResponse, CreateCohortData, CreateCohortResponse, CreateContactData, CreateContactResponse, CreateMedicationData, CreateMedicationResponse, CreateOrganizationData, CreateOrganizationResponse, CreateParticipantData, CreateParticipantResponse, CreateProfileData, CreateProfileResponse, CreateSiteData, CreateSiteResponse, CreateTrialData, CreateTrialResponse, CreateTrialSetupRequestData, CreateTrialSetupRequestResponse, CsrfTokenData, CsrfTokenResponse2, DeactivateUserData, DeactivateUserResponse, DeleteCohortData, DeleteCohortResponse, DeleteContactData, DeleteContactResponse, DeleteMedicationData, DeleteMedicationNestedData, DeleteMedicationNestedResponse, DeleteMedicationResponse, DeleteOrganizationData, DeleteOrganizationResponse, DeleteParticipantData, DeleteParticipantResponse, DeletePasskeyData, DeleteProfileData, DeleteProfileResponse, DeleteSiteData, DeleteSiteResponse, DeleteTrialData, DeleteTrialParticipantData, DeleteTrialParticipantResponse, DeleteTrialResponse, DeleteTrialSetupRequestData, DeleteTrialSetupRequestResponse, DeleteUserData, DeleteUserResponse, DeviceHealthSummaryData, DeviceHealthSummaryResponse2, Disable2FaData, Disable2FaResponse, DownloadAttachmentData, Enable2FaData, Enable2FaResponse, EnrollData, EnrollPassphraseData, EnrollPassphraseResponse, EnrollResponse, ExportAuditLogs2Data, ExportAuditLogs3Data, ExportAuditLogsData, ExportDeliveriesData, ExportUsersData, Generate2FaData, Generate2FaResponse, GenerateEnrollmentFormsData, GetAccessibleResourcesData, GetAccessibleResourcesResponse, GetByTrialAndSerialData, GetByTrialAndSerialResponse, GetCohortData, GetCohortResponse, GetDeliveryContentData, GetDeliveryData, GetDeliveryResponse, GetDetailedData, GetDetailedResponse, GetEnrollmentData, GetEnrollmentResponse, GetEventData, GetEventResponse, GetEventSummaryData, GetEventSummaryResponse, GetMapsTokenData, GetMapsTokenResponse, GetMeData, GetMedicationData, GetMedicationNestedData, GetMedicationNestedResponse, GetMedicationResponse, GetMedicationSlots2Data, GetMedicationSlots2Response, GetMedicationSlotsData, GetMedicationSlotsResponse, GetMeResponse, GetMetadata2Data, GetMetadata2Response, GetMetadataData, GetMetadataResponse, GetMyAccessibleResourcesData, GetMyAccessibleResourcesResponse, GetMyPermissionsData, GetMyPermissionsResponse, GetOrganizationBySlugData, GetOrganizationBySlugResponse, GetOrganizationDashboardData, GetOrganizationDashboardResponse, GetOrganizationData, GetOrganizationResponse, GetParticipantAdherenceData, GetParticipantAdherenceResponse, GetParticipantBySlugData, GetParticipantBySlugResponse, GetParticipantData, GetParticipantHealthData, GetParticipantHealthResponse, GetParticipantResponse, GetPopulationAdherenceData, GetPopulationAdherenceResponse, GetProfile2Data, GetProfile2Response, GetProfileData, GetProfileResponse, GetPushStatusData, GetPushStatusResponse, GetSettingsData, GetSettingsResponse, GetSiteData, GetSiteResponse, GetSubmissionData, GetSubmissionResponse, GetTrialBySlugData, GetTrialBySlugResponse, GetTrialData, GetTrialLiveFeedData, GetTrialLiveFeedResponse, GetTrialParticipantData, GetTrialParticipantResponse, GetTrialResponse, GetTrialSetupRequestData, GetTrialSetupRequestResponse, GetUnreadCountData, GetUnreadCountResponse, GetUserPermissionsData, GetUserPermissionsResponse, GetUserStatisticsData, GetUserStatisticsResponse, GrantPermissionsData, GrantPermissionsResponse, HeartbeatData, HeartbeatResponse2, ListAuditLogs2Data, ListAuditLogs2Response, ListAuditLogsData, ListAuditLogsResponse, ListCohortsData, ListCohortsResponse, ListContactsData, ListContactsResponse, ListDeliveriesData, ListDeliveriesResponse, ListDeliveryAttachmentsData, ListDeliveryAttachmentsResponse, ListDispensersAliasData, ListDispensersAliasResponse, ListDispensersData, ListDispensersResponse, ListEventsData, ListEventsResponse, ListInvitationsData, ListInvitationsResponse, ListMedicationsData, ListMedicationsResponse, ListNotificationsData, ListNotificationsResponse, ListOrganizationsData, ListOrganizationsResponse, ListParticipantsData, ListParticipantsResponse, ListPasskeysData, ListPasskeysResponse, ListPermissionsData, ListPermissionsResponse, ListProfilesData, ListProfilesResponse, ListSitesData, ListSitesResponse, ListTrialsData, ListTrialSetupRequestsData, ListTrialSetupRequestsResponse, ListTrialsResponse, ListUsersData, ListUsersResponse, Login2FaData, Login2FaResponse, LoginData, LoginResponse2, LogoutData, LogoutResponse, MarkAllAsReadData, MarkAllAsReadResponse, MarkAsReadData, MarkAsReadResponse, PasswordRecoveryData, PasswordRecoveryResponse, PasswordResetData, PasswordResetResponse, PreviewProfileData, PreviewProfileResponse, PushSendData, PushSendResponse, RefreshData, RefreshResponse, RegisterFinishData, RegisterFinishResponse, RegisterPushTokenData, RegisterPushTokenResponse2, RegisterStartData, RegisterStartResponse2, RejectTrialSetupRequestData, RejectTrialSetupRequestResponse, RequestVerificationData, RequestVerificationResponse, ResetParticipantEnrollmentData, ResetParticipantEnrollmentResponse, ResetTrialEnrollmentData, ResetTrialEnrollmentResponse, ResolveEventData, ResolveEventResponse, RevokeInvitationData, RevokeInvitationResponse, RevokePermissionsData, RevokePermissionsResponse, SendInvitationData, SendInvitationResponse, SendParticipantPushData, SendParticipantPushResponse, SendStudyMessageData, SendStudyMessageResponse2, SubmitData, SubmitResponse, SubmitTrialSetupRequestData, SubmitTrialSetupRequestResponse, SyncBatteryData, SyncBatteryResponse, SyncBulkData, SyncBulkResponse, SyncEventsData, SyncEventsResponse, TestSendProfileData, TestSendProfileResponse, UnarchiveCohortData, UnarchiveCohortResponse, UnarchiveOrganizationData, UnarchiveOrganizationResponse, UnarchiveParticipantData, UnarchiveParticipantResponse, UnarchiveSiteData, UnarchiveSiteResponse, UnarchiveTrialData, UnarchiveTrialResponse, UnassignData, UnassignResponse2, UnenrollClientData, UnenrollClientError, UnenrollClientResponse, UpdateCohortData, UpdateCohortResponse, UpdateContactData, UpdateContactResponse, UpdateMedicationData, UpdateMedicationNestedData, UpdateMedicationNestedResponse, UpdateMedicationResponse, UpdateOrganizationData, UpdateOrganizationResponse, UpdateParticipantData, UpdateParticipantResponse, UpdateProfile2Data, UpdateProfile2Response, UpdateProfileData, UpdateProfileResponse, UpdateSiteData, UpdateSiteResponse, UpdateTrialData, UpdateTrialParticipantData, UpdateTrialParticipantResponse, UpdateTrialResponse, UpdateTrialSetupRequestData, UpdateTrialSetupRequestResponse, UpsertSettingsData, UpsertSettingsResponse, ValidateAssignmentsData, ValidateAssignmentsResponse2, VerifyChain2Data, VerifyChain2Response, VerifyChainData, VerifyChainResponse, VerifyTokenData, VerifyTokenResponse2, WithdrawEnrollmentData, WithdrawEnrollmentResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const listAuditLogsQueryKey = (options?: Options<ListAuditLogsData>) => createQueryKey('listAuditLogs', options);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogsOptions = (options?: Options<ListAuditLogsData>) => queryOptions<ListAuditLogsResponse, AxiosError<DefaultError>, ListAuditLogsResponse, ReturnType<typeof listAuditLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAuditLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listAuditLogsInfiniteQueryKey = (options?: Options<ListAuditLogsData>): QueryKey<Options<ListAuditLogsData>> => createQueryKey('listAuditLogs', options, true);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogsInfiniteOptions = (options?: Options<ListAuditLogsData>) => infiniteQueryOptions<ListAuditLogsResponse, AxiosError<DefaultError>, InfiniteData<ListAuditLogsResponse>, QueryKey<Options<ListAuditLogsData>>, number | Pick<QueryKey<Options<ListAuditLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListAuditLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listAuditLogs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogsInfiniteQueryKey(options)
});

export const exportAuditLogsQueryKey = (options?: Options<ExportAuditLogsData>) => createQueryKey('exportAuditLogs', options);

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogsOptions = (options?: Options<ExportAuditLogsData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof exportAuditLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportAuditLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportAuditLogsQueryKey(options)
});

export const getMetadataQueryKey = (options?: Options<GetMetadataData>) => createQueryKey('getMetadata', options);

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadataOptions = (options?: Options<GetMetadataData>) => queryOptions<GetMetadataResponse, AxiosError<DefaultError>, GetMetadataResponse, ReturnType<typeof getMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetadataQueryKey(options)
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChainMutation = (options?: Partial<Options<VerifyChainData>>): UseMutationOptions<VerifyChainResponse, AxiosError<DefaultError>, Options<VerifyChainData>> => {
    const mutationOptions: UseMutationOptions<VerifyChainResponse, AxiosError<DefaultError>, Options<VerifyChainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyChain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export audit logs as CSV or JSON.
 */
export const exportAuditLogs2Mutation = (options?: Partial<Options<ExportAuditLogs2Data>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ExportAuditLogs2Data>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ExportAuditLogs2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportAuditLogs2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export users as CSV or JSON.
 */
export const exportUsersMutation = (options?: Partial<Options<ExportUsersData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ExportUsersData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ExportUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInvitationsQueryKey = (options?: Options<ListInvitationsData>) => createQueryKey('listInvitations', options);

/**
 * List all invitations (paginated).
 *
 * Returns active (non-archived) invitations sorted by `created_at` descending.
 * Supports text search on email and status filter (`pending`, `accepted`, `expired`).
 */
export const listInvitationsOptions = (options?: Options<ListInvitationsData>) => queryOptions<ListInvitationsResponse, AxiosError<DefaultError>, ListInvitationsResponse, ReturnType<typeof listInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvitationsQueryKey(options)
});

export const listInvitationsInfiniteQueryKey = (options?: Options<ListInvitationsData>): QueryKey<Options<ListInvitationsData>> => createQueryKey('listInvitations', options, true);

/**
 * List all invitations (paginated).
 *
 * Returns active (non-archived) invitations sorted by `created_at` descending.
 * Supports text search on email and status filter (`pending`, `accepted`, `expired`).
 */
export const listInvitationsInfiniteOptions = (options?: Options<ListInvitationsData>) => infiniteQueryOptions<ListInvitationsResponse, AxiosError<DefaultError>, InfiniteData<ListInvitationsResponse>, QueryKey<Options<ListInvitationsData>>, number | Pick<QueryKey<Options<ListInvitationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListInvitationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInvitations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvitationsInfiniteQueryKey(options)
});

/**
 * Send a single invitation.
 *
 * Creates an invitation record for the given email address. The email must not
 * already be registered as a user or have an active (non-archived, non-expired)
 * invitation. Returns a message on success.
 */
export const sendInvitationMutation = (options?: Partial<Options<SendInvitationData>>): UseMutationOptions<SendInvitationResponse, AxiosError<DefaultError>, Options<SendInvitationData>> => {
    const mutationOptions: UseMutationOptions<SendInvitationResponse, AxiosError<DefaultError>, Options<SendInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send bulk invitations.
 *
 * Attempts to create an invitation for each email address. Emails that are
 * already registered or already have active invitations are skipped and
 * reported in the `failed` map.
 */
export const bulkSendMutation = (options?: Partial<Options<BulkSendData>>): UseMutationOptions<BulkSendResponse2, AxiosError<DefaultError>, Options<BulkSendData>> => {
    const mutationOptions: UseMutationOptions<BulkSendResponse2, AxiosError<DefaultError>, Options<BulkSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate emails for bulk invitation.
 *
 * For each email, checks format validity, whether it is already registered,
 * and whether an active invitation already exists. Returns categorized results.
 */
export const bulkValidateMutation = (options?: Partial<Options<BulkValidateData>>): UseMutationOptions<BulkValidateResponse2, AxiosError<DefaultError>, Options<BulkValidateData>> => {
    const mutationOptions: UseMutationOptions<BulkValidateResponse2, AxiosError<DefaultError>, Options<BulkValidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkValidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke (archive) an invitation.
 *
 * Soft-deletes the invitation by setting `archived_at` and `archived_by_id`.
 * Returns a message on success.
 */
export const revokeInvitationMutation = (options?: Partial<Options<RevokeInvitationData>>): UseMutationOptions<RevokeInvitationResponse, AxiosError<DefaultError>, Options<RevokeInvitationData>> => {
    const mutationOptions: UseMutationOptions<RevokeInvitationResponse, AxiosError<DefaultError>, Options<RevokeInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUsersQueryKey = (options?: Options<ListUsersData>) => createQueryKey('listUsers', options);

/**
 * List all users (admin only) — with organization count enrichment.
 */
export const listUsersOptions = (options?: Options<ListUsersData>) => queryOptions<ListUsersResponse, AxiosError<DefaultError>, ListUsersResponse, ReturnType<typeof listUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsersQueryKey(options)
});

export const listUsersInfiniteQueryKey = (options?: Options<ListUsersData>): QueryKey<Options<ListUsersData>> => createQueryKey('listUsers', options, true);

/**
 * List all users (admin only) — with organization count enrichment.
 */
export const listUsersInfiniteOptions = (options?: Options<ListUsersData>) => infiniteQueryOptions<ListUsersResponse, AxiosError<DefaultError>, InfiniteData<ListUsersResponse>, QueryKey<Options<ListUsersData>>, number | Pick<QueryKey<Options<ListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsersInfiniteQueryKey(options)
});

/**
 * Delete or archive a user (admin only).
 *
 * If the user owns organizations with participants, the user is archived
 * instead of deleted to preserve referential integrity.
 */
export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>): UseMutationOptions<DeleteUserResponse, AxiosError<DefaultError>, Options<DeleteUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserResponse, AxiosError<DefaultError>, Options<DeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Activate a user (admin only) — with enrichment.
 */
export const activateUserMutation = (options?: Partial<Options<ActivateUserData>>): UseMutationOptions<ActivateUserResponse, AxiosError<DefaultError>, Options<ActivateUserData>> => {
    const mutationOptions: UseMutationOptions<ActivateUserResponse, AxiosError<DefaultError>, Options<ActivateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deactivate a user (admin only) — with enrichment.
 */
export const deactivateUserMutation = (options?: Partial<Options<DeactivateUserData>>): UseMutationOptions<DeactivateUserResponse, AxiosError<DefaultError>, Options<DeactivateUserData>> => {
    const mutationOptions: UseMutationOptions<DeactivateUserResponse, AxiosError<DefaultError>, Options<DeactivateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserStatisticsQueryKey = (options: Options<GetUserStatisticsData>) => createQueryKey('getUserStatistics', options);

/**
 * Get user activity statistics (admin only) — with organization enrichment.
 */
export const getUserStatisticsOptions = (options: Options<GetUserStatisticsData>) => queryOptions<GetUserStatisticsResponse, AxiosError<DefaultError>, GetUserStatisticsResponse, ReturnType<typeof getUserStatisticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserStatistics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserStatisticsQueryKey(options)
});

export const listAuditLogs2QueryKey = (options?: Options<ListAuditLogs2Data>) => createQueryKey('listAuditLogs2', options);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs2Options = (options?: Options<ListAuditLogs2Data>) => queryOptions<ListAuditLogs2Response, AxiosError<DefaultError>, ListAuditLogs2Response, ReturnType<typeof listAuditLogs2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAuditLogs2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogs2QueryKey(options)
});

export const listAuditLogs2InfiniteQueryKey = (options?: Options<ListAuditLogs2Data>): QueryKey<Options<ListAuditLogs2Data>> => createQueryKey('listAuditLogs2', options, true);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs2InfiniteOptions = (options?: Options<ListAuditLogs2Data>) => infiniteQueryOptions<ListAuditLogs2Response, AxiosError<DefaultError>, InfiniteData<ListAuditLogs2Response>, QueryKey<Options<ListAuditLogs2Data>>, number | Pick<QueryKey<Options<ListAuditLogs2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListAuditLogs2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listAuditLogs2({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogs2InfiniteQueryKey(options)
});

export const exportAuditLogs3QueryKey = (options?: Options<ExportAuditLogs3Data>) => createQueryKey('exportAuditLogs3', options);

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogs3Options = (options?: Options<ExportAuditLogs3Data>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof exportAuditLogs3QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportAuditLogs3({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportAuditLogs3QueryKey(options)
});

export const getMetadata2QueryKey = (options?: Options<GetMetadata2Data>) => createQueryKey('getMetadata2', options);

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadata2Options = (options?: Options<GetMetadata2Data>) => queryOptions<GetMetadata2Response, AxiosError<DefaultError>, GetMetadata2Response, ReturnType<typeof getMetadata2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetadata2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetadata2QueryKey(options)
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChain2Mutation = (options?: Partial<Options<VerifyChain2Data>>): UseMutationOptions<VerifyChain2Response, AxiosError<DefaultError>, Options<VerifyChain2Data>> => {
    const mutationOptions: UseMutationOptions<VerifyChain2Response, AxiosError<DefaultError>, Options<VerifyChain2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyChain2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept an invitation and create a new user account.
 */
export const acceptInvitationMutation = (options?: Partial<Options<AcceptInvitationData>>): UseMutationOptions<AcceptInvitationResponse, AxiosError<DefaultError>, Options<AcceptInvitationData>> => {
    const mutationOptions: UseMutationOptions<AcceptInvitationResponse, AxiosError<DefaultError>, Options<AcceptInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Authenticate and receive a JWT token.
 */
export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<LoginResponse2, AxiosError<DefaultError>, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<LoginResponse2, AxiosError<DefaultError>, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete two-factor authentication login.
 */
export const login2FaMutation = (options?: Partial<Options<Login2FaData>>): UseMutationOptions<Login2FaResponse, AxiosError<DefaultError>, Options<Login2FaData>> => {
    const mutationOptions: UseMutationOptions<Login2FaResponse, AxiosError<DefaultError>, Options<Login2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Log out the current user by blacklisting their token.
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, AxiosError<DefaultError>, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, AxiosError<DefaultError>, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProfileQueryKey = (options?: Options<GetProfileData>) => createQueryKey('getProfile', options);

/**
 * Get the current authenticated user's profile.
 */
export const getProfileOptions = (options?: Options<GetProfileData>) => queryOptions<GetProfileResponse, AxiosError<DefaultError>, GetProfileResponse, ReturnType<typeof getProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProfileQueryKey(options)
});

/**
 * Complete passkey authentication and issue a JWT.
 */
export const authFinishMutation = (options?: Partial<Options<AuthFinishData>>): UseMutationOptions<AuthFinishResponse, AxiosError<DefaultError>, Options<AuthFinishData>> => {
    const mutationOptions: UseMutationOptions<AuthFinishResponse, AxiosError<DefaultError>, Options<AuthFinishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authFinish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start passkey authentication.
 *
 * Accepts the user's email. If the user has registered passkeys, returns
 * `WebAuthn` request options with `allowCredentials` populated so that
 * password managers can match the credential. If the user has no passkeys
 * (or the email is unknown), returns `{ has_passkeys: false }` without
 * revealing whether the email exists.
 */
export const authStartMutation = (options?: Partial<Options<AuthStartData>>): UseMutationOptions<AuthStartResponse2, AxiosError<DefaultError>, Options<AuthStartData>> => {
    const mutationOptions: UseMutationOptions<AuthStartResponse2, AxiosError<DefaultError>, Options<AuthStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request a password reset email.
 *
 * Always returns success to prevent email enumeration.
 */
export const passwordRecoveryMutation = (options?: Partial<Options<PasswordRecoveryData>>): UseMutationOptions<PasswordRecoveryResponse, AxiosError<DefaultError>, Options<PasswordRecoveryData>> => {
    const mutationOptions: UseMutationOptions<PasswordRecoveryResponse, AxiosError<DefaultError>, Options<PasswordRecoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passwordRecovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset password using a token received via email.
 */
export const passwordResetMutation = (options?: Partial<Options<PasswordResetData>>): UseMutationOptions<PasswordResetResponse, AxiosError<DefaultError>, Options<PasswordResetData>> => {
    const mutationOptions: UseMutationOptions<PasswordResetResponse, AxiosError<DefaultError>, Options<PasswordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passwordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a dispenser assignment for the enrolled participant.
 *
 * Links a dispenser (by serial number) to a medication slot belonging to the
 * authenticated participant. Creates the dispenser record if it doesn't exist.
 * Idempotent: returns 200 if the exact assignment already exists, 201 if new.
 */
export const createAssignmentMutation = (options?: Partial<Options<CreateAssignmentData>>): UseMutationOptions<CreateAssignmentResponse, AxiosError<DefaultError>, Options<CreateAssignmentData>> => {
    const mutationOptions: UseMutationOptions<CreateAssignmentResponse, AxiosError<DefaultError>, Options<CreateAssignmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAssignment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pre-flight validate a batch of dispenser assignments.
 *
 * Checks whether each assignment would succeed without creating anything.
 * Returns one result per input item.
 */
export const validateAssignmentsMutation = (options?: Partial<Options<ValidateAssignmentsData>>): UseMutationOptions<ValidateAssignmentsResponse2, AxiosError<DefaultError>, Options<ValidateAssignmentsData>> => {
    const mutationOptions: UseMutationOptions<ValidateAssignmentsResponse2, AxiosError<DefaultError>, Options<ValidateAssignmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateAssignments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign a dispenser from its current medication slot.
 *
 * Marks the active assignment for the given dispenser as inactive and records
 * the unassignment timestamp and optional reason. Idempotent.
 */
export const unassignMutation = (options?: Partial<Options<UnassignData>>): UseMutationOptions<UnassignResponse2, AxiosError<DefaultError>, Options<UnassignData>> => {
    const mutationOptions: UseMutationOptions<UnassignResponse2, AxiosError<DefaultError>, Options<UnassignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unassign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enroll a device using an enrollment token.
 *
 * Validates the enrollment token against the participant table, creates or
 * activates the enrollment, and returns a JWT access token.
 */
export const enrollMutation = (options?: Partial<Options<EnrollData>>): UseMutationOptions<EnrollResponse, AxiosError<DefaultError>, Options<EnrollData>> => {
    const mutationOptions: UseMutationOptions<EnrollResponse, AxiosError<DefaultError>, Options<EnrollData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enroll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enroll a device using a human-friendly passphrase.
 *
 * Normalizes the input (lowercase, trim, replace spaces with hyphens),
 * resolves the participant by passphrase, then delegates to the standard
 * enrollment flow.
 */
export const enrollPassphraseMutation = (options?: Partial<Options<EnrollPassphraseData>>): UseMutationOptions<EnrollPassphraseResponse, AxiosError<DefaultError>, Options<EnrollPassphraseData>> => {
    const mutationOptions: UseMutationOptions<EnrollPassphraseResponse, AxiosError<DefaultError>, Options<EnrollPassphraseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enrollPassphrase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Device heartbeat — records app status, device health, and connection logs.
 *
 * Called periodically by the Hermes mobile app. Stores per-device status
 * snapshots, BLE connection logs (deduplicated by client log ID), and
 * returns client configuration from trial settings.
 */
export const heartbeatMutation = (options?: Partial<Options<HeartbeatData>>): UseMutationOptions<HeartbeatResponse2, AxiosError<DefaultError>, Options<HeartbeatData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatResponse2, AxiosError<DefaultError>, Options<HeartbeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

/**
 * Get the authenticated enrollment's information.
 *
 * Returns participant and enrollment details along with active dispenser
 * assignments.
 */
export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, AxiosError<DefaultError>, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const getMedicationSlotsQueryKey = (options?: Options<GetMedicationSlotsData>) => createQueryKey('getMedicationSlots', options);

/**
 * Get medication slots for the authenticated participant.
 *
 * Returns the participant's medication slots along with their medication
 * requirements and any current dispenser assignments.
 */
export const getMedicationSlotsOptions = (options?: Options<GetMedicationSlotsData>) => queryOptions<GetMedicationSlotsResponse, AxiosError<DefaultError>, GetMedicationSlotsResponse, ReturnType<typeof getMedicationSlotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMedicationSlots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMedicationSlotsQueryKey(options)
});

/**
 * Register a push notification token for this enrollment.
 *
 * Upserts: if a registration exists for this enrollment, updates the token
 * and resets failures. Otherwise creates a new registration.
 */
export const registerPushTokenMutation = (options?: Partial<Options<RegisterPushTokenData>>): UseMutationOptions<RegisterPushTokenResponse2, AxiosError<DefaultError>, Options<RegisterPushTokenData>> => {
    const mutationOptions: UseMutationOptions<RegisterPushTokenResponse2, AxiosError<DefaultError>, Options<RegisterPushTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerPushToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh a client access token using an enrollment token.
 *
 * Same flow as enrollment but requires an existing active enrollment.
 */
export const refreshMutation = (options?: Partial<Options<RefreshData>>): UseMutationOptions<RefreshResponse, AxiosError<DefaultError>, Options<RefreshData>> => {
    const mutationOptions: UseMutationOptions<RefreshResponse, AxiosError<DefaultError>, Options<RefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refresh({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a battery reading for a dispenser.
 *
 * Records a single battery voltage and percentage measurement.
 */
export const syncBatteryMutation = (options?: Partial<Options<SyncBatteryData>>): UseMutationOptions<SyncBatteryResponse, AxiosError<DefaultError>, Options<SyncBatteryData>> => {
    const mutationOptions: UseMutationOptions<SyncBatteryResponse, AxiosError<DefaultError>, Options<SyncBatteryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncBattery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk sync events and battery readings for multiple dispensers.
 *
 * Accepts a map of dispenser serial numbers to their sync payloads, allowing
 * the client to batch all pending data in a single request.
 */
export const syncBulkMutation = (options?: Partial<Options<SyncBulkData>>): UseMutationOptions<SyncBulkResponse, AxiosError<DefaultError>, Options<SyncBulkData>> => {
    const mutationOptions: UseMutationOptions<SyncBulkResponse, AxiosError<DefaultError>, Options<SyncBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncBulk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit dispenser events for processing.
 *
 * Receives hex-encoded dispenser events and processes them. Duplicate events
 * are detected and skipped.
 */
export const syncEventsMutation = (options?: Partial<Options<SyncEventsData>>): UseMutationOptions<SyncEventsResponse, AxiosError<DefaultError>, Options<SyncEventsData>> => {
    const mutationOptions: UseMutationOptions<SyncEventsResponse, AxiosError<DefaultError>, Options<SyncEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unenroll (withdraw) the authenticated participant.
 *
 * Sets enrollment status to `WITHDRAWN` and deactivates all active
 * assignments. Idempotent: returns 409 if the enrollment is already
 * in a terminal state.
 */
export const unenrollClientMutation = (options?: Partial<Options<UnenrollClientData>>): UseMutationOptions<UnenrollClientResponse, AxiosError<UnenrollClientError>, Options<UnenrollClientData>> => {
    const mutationOptions: UseMutationOptions<UnenrollClientResponse, AxiosError<UnenrollClientError>, Options<UnenrollClientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unenrollClient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Smart delete a cohort.
 *
 * Calculates deletion strategy based on resource state:
 * - **No participants** → hard delete (permanent removal)
 * - **Has participants** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteCohortMutation = (options?: Partial<Options<DeleteCohortData>>): UseMutationOptions<DeleteCohortResponse, AxiosError<DefaultError>, Options<DeleteCohortData>> => {
    const mutationOptions: UseMutationOptions<DeleteCohortResponse, AxiosError<DefaultError>, Options<DeleteCohortData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCohort({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCohortQueryKey = (options: Options<GetCohortData>) => createQueryKey('getCohort', options);

/**
 * Get a cohort by ID.
 */
export const getCohortOptions = (options: Options<GetCohortData>) => queryOptions<GetCohortResponse, AxiosError<DefaultError>, GetCohortResponse, ReturnType<typeof getCohortQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCohort({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCohortQueryKey(options)
});

/**
 * Update a cohort (PUT).
 *
 * When the name changes, the slug is regenerated automatically.
 * Parent trial must not be archived.
 */
export const updateCohortMutation = (options?: Partial<Options<UpdateCohortData>>): UseMutationOptions<UpdateCohortResponse, AxiosError<DefaultError>, Options<UpdateCohortData>> => {
    const mutationOptions: UseMutationOptions<UpdateCohortResponse, AxiosError<DefaultError>, Options<UpdateCohortData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCohort({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unarchive (restore) an archived cohort. System admin only.
 *
 * Checks that the parent trial is not archived before restoring.
 */
export const unarchiveCohortMutation = (options?: Partial<Options<UnarchiveCohortData>>): UseMutationOptions<UnarchiveCohortResponse, AxiosError<DefaultError>, Options<UnarchiveCohortData>> => {
    const mutationOptions: UseMutationOptions<UnarchiveCohortResponse, AxiosError<DefaultError>, Options<UnarchiveCohortData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unarchiveCohort({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const csrfTokenQueryKey = (options?: Options<CsrfTokenData>) => createQueryKey('csrfToken', options);

/**
 * Generate a CSRF token.
 *
 * Returns an HMAC-signed CSRF token in the format `{timestamp}:{random_hex}:{signature}`.
 * Returns an HMAC-signed CSRF token.
 *
 * - `timestamp` — Unix epoch seconds
 * - `random_hex` — 16 random bytes, hex-encoded (32 chars)
 * - `signature` — HMAC-SHA256 of `{timestamp}:{random_hex}`, hex-encoded (64 chars)
 */
export const csrfTokenOptions = (options?: Options<CsrfTokenData>) => queryOptions<CsrfTokenResponse2, AxiosError<DefaultError>, CsrfTokenResponse2, ReturnType<typeof csrfTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await csrfToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: csrfTokenQueryKey(options)
});

export const listDispensersQueryKey = (options?: Options<ListDispensersData>) => createQueryKey('listDispensers', options);

/**
 * List dispensers (paginated, filterable) with enriched relations.
 *
 * Returns dispensers with battery status, connectivity, assignment info,
 * sync status, and resource state.
 */
export const listDispensersOptions = (options?: Options<ListDispensersData>) => queryOptions<ListDispensersResponse, AxiosError<DefaultError>, ListDispensersResponse, ReturnType<typeof listDispensersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDispensers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDispensersQueryKey(options)
});

export const listDispensersInfiniteQueryKey = (options?: Options<ListDispensersData>): QueryKey<Options<ListDispensersData>> => createQueryKey('listDispensers', options, true);

/**
 * List dispensers (paginated, filterable) with enriched relations.
 *
 * Returns dispensers with battery status, connectivity, assignment info,
 * sync status, and resource state.
 */
export const listDispensersInfiniteOptions = (options?: Options<ListDispensersData>) => infiniteQueryOptions<ListDispensersResponse, AxiosError<DefaultError>, InfiniteData<ListDispensersResponse>, QueryKey<Options<ListDispensersData>>, number | Pick<QueryKey<Options<ListDispensersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDispensersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDispensers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDispensersInfiniteQueryKey(options)
});

export const listDispensersAliasQueryKey = (options?: Options<ListDispensersAliasData>) => createQueryKey('listDispensersAlias', options);

/**
 * Alias endpoint: `/api/v1/dispensers/with-relations`.
 *
 * Delegates to `list_dispensers` for Python frontend compatibility.
 */
export const listDispensersAliasOptions = (options?: Options<ListDispensersAliasData>) => queryOptions<ListDispensersAliasResponse, AxiosError<DefaultError>, ListDispensersAliasResponse, ReturnType<typeof listDispensersAliasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDispensersAlias({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDispensersAliasQueryKey(options)
});

export const listDispensersAliasInfiniteQueryKey = (options?: Options<ListDispensersAliasData>): QueryKey<Options<ListDispensersAliasData>> => createQueryKey('listDispensersAlias', options, true);

/**
 * Alias endpoint: `/api/v1/dispensers/with-relations`.
 *
 * Delegates to `list_dispensers` for Python frontend compatibility.
 */
export const listDispensersAliasInfiniteOptions = (options?: Options<ListDispensersAliasData>) => infiniteQueryOptions<ListDispensersAliasResponse, AxiosError<DefaultError>, InfiniteData<ListDispensersAliasResponse>, QueryKey<Options<ListDispensersAliasData>>, number | Pick<QueryKey<Options<ListDispensersAliasData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDispensersAliasData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDispensersAlias({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDispensersAliasInfiniteQueryKey(options)
});

export const assignmentTimelineQueryKey = (options: Options<AssignmentTimelineData>) => createQueryKey('assignmentTimeline', options);

/**
 * Get assignment timeline for a dispenser.
 *
 * Returns enriched timeline events for all assignments (active and historical).
 */
export const assignmentTimelineOptions = (options: Options<AssignmentTimelineData>) => queryOptions<AssignmentTimelineResponse, AxiosError<DefaultError>, AssignmentTimelineResponse, ReturnType<typeof assignmentTimelineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assignmentTimeline({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assignmentTimelineQueryKey(options)
});

export const auditEventsQueryKey = (options: Options<AuditEventsData>) => createQueryKey('auditEvents', options);

/**
 * Get dispenser audit events (paginated) with severity and description.
 *
 * Returns enriched dispenser events for a specific dispenser.
 */
export const auditEventsOptions = (options: Options<AuditEventsData>) => queryOptions<AuditEventsResponse, AxiosError<DefaultError>, AuditEventsResponse, ReturnType<typeof auditEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditEventsQueryKey(options)
});

export const auditEventsInfiniteQueryKey = (options: Options<AuditEventsData>): QueryKey<Options<AuditEventsData>> => createQueryKey('auditEvents', options, true);

/**
 * Get dispenser audit events (paginated) with severity and description.
 *
 * Returns enriched dispenser events for a specific dispenser.
 */
export const auditEventsInfiniteOptions = (options: Options<AuditEventsData>) => infiniteQueryOptions<AuditEventsResponse, AxiosError<DefaultError>, InfiniteData<AuditEventsResponse>, QueryKey<Options<AuditEventsData>>, number | Pick<QueryKey<Options<AuditEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AuditEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await auditEvents({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditEventsInfiniteQueryKey(options)
});

export const batteryTrendQueryKey = (options: Options<BatteryTrendData>) => createQueryKey('batteryTrend', options);

/**
 * Get battery trend with summary and trend direction.
 *
 * Returns the most recent battery readings with computed summary statistics
 * and trend direction (improving/stable/declining).
 */
export const batteryTrendOptions = (options: Options<BatteryTrendData>) => queryOptions<BatteryTrendResponse2, AxiosError<DefaultError>, BatteryTrendResponse2, ReturnType<typeof batteryTrendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await batteryTrend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: batteryTrendQueryKey(options)
});

export const connectionLogsQueryKey = (options: Options<ConnectionLogsData>) => createQueryKey('connectionLogs', options);

/**
 * List connection logs for a dispenser.
 *
 * Returns paginated BLE connection attempt logs with search and filters.
 */
export const connectionLogsOptions = (options: Options<ConnectionLogsData>) => queryOptions<ConnectionLogsResponse, AxiosError<DefaultError>, ConnectionLogsResponse, ReturnType<typeof connectionLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await connectionLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: connectionLogsQueryKey(options)
});

export const connectionLogsInfiniteQueryKey = (options: Options<ConnectionLogsData>): QueryKey<Options<ConnectionLogsData>> => createQueryKey('connectionLogs', options, true);

/**
 * List connection logs for a dispenser.
 *
 * Returns paginated BLE connection attempt logs with search and filters.
 */
export const connectionLogsInfiniteOptions = (options: Options<ConnectionLogsData>) => infiniteQueryOptions<ConnectionLogsResponse, AxiosError<DefaultError>, InfiniteData<ConnectionLogsResponse>, QueryKey<Options<ConnectionLogsData>>, number | Pick<QueryKey<Options<ConnectionLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ConnectionLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await connectionLogs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: connectionLogsInfiniteQueryKey(options)
});

export const getDetailedQueryKey = (options: Options<GetDetailedData>) => createQueryKey('getDetailed', options);

/**
 * Get detailed dispenser info by slug.
 *
 * Returns the dispenser with enriched battery, connectivity, assignment, and
 * resource state information.
 */
export const getDetailedOptions = (options: Options<GetDetailedData>) => queryOptions<GetDetailedResponse, AxiosError<DefaultError>, GetDetailedResponse, ReturnType<typeof getDetailedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDetailed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDetailedQueryKey(options)
});

export const getMapsTokenQueryKey = (options?: Options<GetMapsTokenData>) => createQueryKey('getMapsToken', options);

/**
 * Get a maps authentication token.
 *
 * Returns a credential the frontend uses with the Azure Maps SDK.
 * Requires an authenticated user session.
 */
export const getMapsTokenOptions = (options?: Options<GetMapsTokenData>) => queryOptions<GetMapsTokenResponse, AxiosError<DefaultError>, GetMapsTokenResponse, ReturnType<typeof getMapsTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMapsToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMapsTokenQueryKey(options)
});

/**
 * Smart delete a medication requirement.
 *
 * Calculates deletion strategy based on resource state:
 * - **No medication slots** -> hard delete (permanent removal)
 * - **Has slots** -> archive (soft delete)
 * - **Already archived** -> error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteMedicationMutation = (options?: Partial<Options<DeleteMedicationData>>): UseMutationOptions<DeleteMedicationResponse, AxiosError<DefaultError>, Options<DeleteMedicationData>> => {
    const mutationOptions: UseMutationOptions<DeleteMedicationResponse, AxiosError<DefaultError>, Options<DeleteMedicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMedication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMedicationQueryKey = (options: Options<GetMedicationData>) => createQueryKey('getMedication', options);

/**
 * Get a medication requirement by ID.
 */
export const getMedicationOptions = (options: Options<GetMedicationData>) => queryOptions<GetMedicationResponse, AxiosError<DefaultError>, GetMedicationResponse, ReturnType<typeof getMedicationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMedication({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMedicationQueryKey(options)
});

/**
 * Update a medication requirement (PUT).
 *
 * Both `dose_mg` and `pills_per_day` are optional; only provided fields are updated.
 * Parent cohort must not be archived.
 */
export const updateMedicationMutation = (options?: Partial<Options<UpdateMedicationData>>): UseMutationOptions<UpdateMedicationResponse, AxiosError<DefaultError>, Options<UpdateMedicationData>> => {
    const mutationOptions: UseMutationOptions<UpdateMedicationResponse, AxiosError<DefaultError>, Options<UpdateMedicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMedication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listNotificationsQueryKey = (options?: Options<ListNotificationsData>) => createQueryKey('listNotifications', options);

/**
 * List current user's notifications.
 */
export const listNotificationsOptions = (options?: Options<ListNotificationsData>) => queryOptions<ListNotificationsResponse, AxiosError<DefaultError>, ListNotificationsResponse, ReturnType<typeof listNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNotificationsQueryKey(options)
});

export const listNotificationsInfiniteQueryKey = (options?: Options<ListNotificationsData>): QueryKey<Options<ListNotificationsData>> => createQueryKey('listNotifications', options, true);

/**
 * List current user's notifications.
 */
export const listNotificationsInfiniteOptions = (options?: Options<ListNotificationsData>) => infiniteQueryOptions<ListNotificationsResponse, AxiosError<DefaultError>, InfiniteData<ListNotificationsResponse>, QueryKey<Options<ListNotificationsData>>, number | null | Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listNotifications({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNotificationsInfiniteQueryKey(options)
});

export const getUnreadCountQueryKey = (options?: Options<GetUnreadCountData>) => createQueryKey('getUnreadCount', options);

/**
 * Get unread notification count (lightweight for polling).
 */
export const getUnreadCountOptions = (options?: Options<GetUnreadCountData>) => queryOptions<GetUnreadCountResponse, AxiosError<DefaultError>, GetUnreadCountResponse, ReturnType<typeof getUnreadCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUnreadCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUnreadCountQueryKey(options)
});

/**
 * Mark all notifications as read.
 */
export const markAllAsReadMutation = (options?: Partial<Options<MarkAllAsReadData>>): UseMutationOptions<MarkAllAsReadResponse, AxiosError<DefaultError>, Options<MarkAllAsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAllAsReadResponse, AxiosError<DefaultError>, Options<MarkAllAsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAllAsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark a single notification as read.
 */
export const markAsReadMutation = (options?: Partial<Options<MarkAsReadData>>): UseMutationOptions<MarkAsReadResponse, AxiosError<DefaultError>, Options<MarkAsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAsReadResponse, AxiosError<DefaultError>, Options<MarkAsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationsQueryKey = (options?: Options<ListOrganizationsData>) => createQueryKey('listOrganizations', options);

/**
 * List organizations the user has access to (paginated).
 *
 * Returns organizations with pagination, sorting, and search.
 * Supports filtering by status: "active" (default), "archived", or "all".
 *
 * **Permission filtering:**
 * - System admins/viewers see all organizations
 * - Regular users see only organizations they have explicit permissions on
 */
export const listOrganizationsOptions = (options?: Options<ListOrganizationsData>) => queryOptions<ListOrganizationsResponse, AxiosError<DefaultError>, ListOrganizationsResponse, ReturnType<typeof listOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationsQueryKey(options)
});

export const listOrganizationsInfiniteQueryKey = (options?: Options<ListOrganizationsData>): QueryKey<Options<ListOrganizationsData>> => createQueryKey('listOrganizations', options, true);

/**
 * List organizations the user has access to (paginated).
 *
 * Returns organizations with pagination, sorting, and search.
 * Supports filtering by status: "active" (default), "archived", or "all".
 *
 * **Permission filtering:**
 * - System admins/viewers see all organizations
 * - Regular users see only organizations they have explicit permissions on
 */
export const listOrganizationsInfiniteOptions = (options?: Options<ListOrganizationsData>) => infiniteQueryOptions<ListOrganizationsResponse, AxiosError<DefaultError>, InfiniteData<ListOrganizationsResponse>, QueryKey<Options<ListOrganizationsData>>, number | Pick<QueryKey<Options<ListOrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListOrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listOrganizations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationsInfiniteQueryKey(options)
});

/**
 * Create a new organization.
 *
 * Requires system admin permission. Slug is auto-generated from the name.
 */
export const createOrganizationMutation = (options?: Partial<Options<CreateOrganizationData>>): UseMutationOptions<CreateOrganizationResponse, AxiosError<DefaultError>, Options<CreateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<CreateOrganizationResponse, AxiosError<DefaultError>, Options<CreateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationBySlugQueryKey = (options: Options<GetOrganizationBySlugData>) => createQueryKey('getOrganizationBySlug', options);

/**
 * Get organization by slug.
 */
export const getOrganizationBySlugOptions = (options: Options<GetOrganizationBySlugData>) => queryOptions<GetOrganizationBySlugResponse, AxiosError<DefaultError>, GetOrganizationBySlugResponse, ReturnType<typeof getOrganizationBySlugQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationBySlug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationBySlugQueryKey(options)
});

/**
 * Smart delete an organization.
 *
 * Calculates deletion strategy based on resource state:
 * - **No trials** → hard delete (permanent removal)
 * - **Has trials** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteOrganizationMutation = (options?: Partial<Options<DeleteOrganizationData>>): UseMutationOptions<DeleteOrganizationResponse, AxiosError<DefaultError>, Options<DeleteOrganizationData>> => {
    const mutationOptions: UseMutationOptions<DeleteOrganizationResponse, AxiosError<DefaultError>, Options<DeleteOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationQueryKey = (options: Options<GetOrganizationData>) => createQueryKey('getOrganization', options);

/**
 * Get organization by ID.
 */
export const getOrganizationOptions = (options: Options<GetOrganizationData>) => queryOptions<GetOrganizationResponse, AxiosError<DefaultError>, GetOrganizationResponse, ReturnType<typeof getOrganizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationQueryKey(options)
});

/**
 * Update an organization.
 *
 * When the name changes, the slug is regenerated automatically.
 * Name uniqueness is checked (case-insensitive, excluding self).
 */
export const updateOrganizationMutation = (options?: Partial<Options<UpdateOrganizationData>>): UseMutationOptions<UpdateOrganizationResponse, AxiosError<DefaultError>, Options<UpdateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationResponse, AxiosError<DefaultError>, Options<UpdateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationDashboardQueryKey = (options: Options<GetOrganizationDashboardData>) => createQueryKey('getOrganizationDashboard', options);

/**
 * Get organization dashboard statistics.
 *
 * Returns the full organization response enriched with participant,
 * dispenser, and activity statistics. Matches Python's `OrganizationDashboard`.
 */
export const getOrganizationDashboardOptions = (options: Options<GetOrganizationDashboardData>) => queryOptions<GetOrganizationDashboardResponse, AxiosError<DefaultError>, GetOrganizationDashboardResponse, ReturnType<typeof getOrganizationDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationDashboardQueryKey(options)
});

/**
 * Unarchive (restore) an archived organization.
 *
 * Requires system admin permission. Returns an error if not archived.
 */
export const unarchiveOrganizationMutation = (options?: Partial<Options<UnarchiveOrganizationData>>): UseMutationOptions<UnarchiveOrganizationResponse, AxiosError<DefaultError>, Options<UnarchiveOrganizationData>> => {
    const mutationOptions: UseMutationOptions<UnarchiveOrganizationResponse, AxiosError<DefaultError>, Options<UnarchiveOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unarchiveOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTrialSetupRequestsQueryKey = (options: Options<ListTrialSetupRequestsData>) => createQueryKey('listTrialSetupRequests', options);

/**
 * List trial setup requests for an organization (paginated).
 *
 * Returns setup requests with pagination, sorting, and search. Filters by
 * status when `?status=` is provided; defaults to showing all non-archived.
 */
export const listTrialSetupRequestsOptions = (options: Options<ListTrialSetupRequestsData>) => queryOptions<ListTrialSetupRequestsResponse, AxiosError<DefaultError>, ListTrialSetupRequestsResponse, ReturnType<typeof listTrialSetupRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTrialSetupRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTrialSetupRequestsQueryKey(options)
});

export const listTrialSetupRequestsInfiniteQueryKey = (options: Options<ListTrialSetupRequestsData>): QueryKey<Options<ListTrialSetupRequestsData>> => createQueryKey('listTrialSetupRequests', options, true);

/**
 * List trial setup requests for an organization (paginated).
 *
 * Returns setup requests with pagination, sorting, and search. Filters by
 * status when `?status=` is provided; defaults to showing all non-archived.
 */
export const listTrialSetupRequestsInfiniteOptions = (options: Options<ListTrialSetupRequestsData>) => infiniteQueryOptions<ListTrialSetupRequestsResponse, AxiosError<DefaultError>, InfiniteData<ListTrialSetupRequestsResponse>, QueryKey<Options<ListTrialSetupRequestsData>>, number | Pick<QueryKey<Options<ListTrialSetupRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListTrialSetupRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTrialSetupRequests({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTrialSetupRequestsInfiniteQueryKey(options)
});

/**
 * Create a new trial setup request.
 *
 * Auto-generates a `public_token` (UUID) and slug from the name.
 * Status starts as "draft".
 */
export const createTrialSetupRequestMutation = (options?: Partial<Options<CreateTrialSetupRequestData>>): UseMutationOptions<CreateTrialSetupRequestResponse, AxiosError<DefaultError>, Options<CreateTrialSetupRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateTrialSetupRequestResponse, AxiosError<DefaultError>, Options<CreateTrialSetupRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTrialSetupRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete or archive a trial setup request. Admin only.
 *
 * Drafts are hard-deleted; all other statuses are archived (soft-deleted).
 * Returns 200 with a deletion response body in both cases (matching Python).
 */
export const deleteTrialSetupRequestMutation = (options?: Partial<Options<DeleteTrialSetupRequestData>>): UseMutationOptions<DeleteTrialSetupRequestResponse, AxiosError<DefaultError>, Options<DeleteTrialSetupRequestData>> => {
    const mutationOptions: UseMutationOptions<DeleteTrialSetupRequestResponse, AxiosError<DefaultError>, Options<DeleteTrialSetupRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTrialSetupRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTrialSetupRequestQueryKey = (options: Options<GetTrialSetupRequestData>) => createQueryKey('getTrialSetupRequest', options);

/**
 * Get a trial setup request by ID.
 */
export const getTrialSetupRequestOptions = (options: Options<GetTrialSetupRequestData>) => queryOptions<GetTrialSetupRequestResponse, AxiosError<DefaultError>, GetTrialSetupRequestResponse, ReturnType<typeof getTrialSetupRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTrialSetupRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTrialSetupRequestQueryKey(options)
});

/**
 * Update a draft trial setup request.
 *
 * Only requests in DRAFT status can be updated. When the name changes,
 * the slug is regenerated automatically.
 */
export const updateTrialSetupRequestMutation = (options?: Partial<Options<UpdateTrialSetupRequestData>>): UseMutationOptions<UpdateTrialSetupRequestResponse, AxiosError<DefaultError>, Options<UpdateTrialSetupRequestData>> => {
    const mutationOptions: UseMutationOptions<UpdateTrialSetupRequestResponse, AxiosError<DefaultError>, Options<UpdateTrialSetupRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTrialSetupRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve a submitted trial setup request. Admin only.
 *
 * Validates form data, then atomically generates a complete trial (with
 * cohorts, sites, medications, participants, and enrollments) from the
 * submission. Status transitions from SUBMITTED to APPROVED.
 */
export const approveTrialSetupRequestMutation = (options?: Partial<Options<ApproveTrialSetupRequestData>>): UseMutationOptions<ApproveTrialSetupRequestResponse, AxiosError<DefaultError>, Options<ApproveTrialSetupRequestData>> => {
    const mutationOptions: UseMutationOptions<ApproveTrialSetupRequestResponse, AxiosError<DefaultError>, Options<ApproveTrialSetupRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approveTrialSetupRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject a submitted trial setup request. Admin only.
 *
 * Transitions status from SUBMITTED to REJECTED with review notes.
 */
export const rejectTrialSetupRequestMutation = (options?: Partial<Options<RejectTrialSetupRequestData>>): UseMutationOptions<RejectTrialSetupRequestResponse, AxiosError<DefaultError>, Options<RejectTrialSetupRequestData>> => {
    const mutationOptions: UseMutationOptions<RejectTrialSetupRequestResponse, AxiosError<DefaultError>, Options<RejectTrialSetupRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectTrialSetupRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a trial setup request for review.
 *
 * Transitions status from DRAFT to SUBMITTED.
 */
export const submitTrialSetupRequestMutation = (options?: Partial<Options<SubmitTrialSetupRequestData>>): UseMutationOptions<SubmitTrialSetupRequestResponse, AxiosError<DefaultError>, Options<SubmitTrialSetupRequestData>> => {
    const mutationOptions: UseMutationOptions<SubmitTrialSetupRequestResponse, AxiosError<DefaultError>, Options<SubmitTrialSetupRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitTrialSetupRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTrialsQueryKey = (options: Options<ListTrialsData>) => createQueryKey('listTrials', options);

/**
 * List trials for an organization (paginated).
 *
 * Returns trials with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listTrialsOptions = (options: Options<ListTrialsData>) => queryOptions<ListTrialsResponse, AxiosError<DefaultError>, ListTrialsResponse, ReturnType<typeof listTrialsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTrials({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTrialsQueryKey(options)
});

export const listTrialsInfiniteQueryKey = (options: Options<ListTrialsData>): QueryKey<Options<ListTrialsData>> => createQueryKey('listTrials', options, true);

/**
 * List trials for an organization (paginated).
 *
 * Returns trials with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listTrialsInfiniteOptions = (options: Options<ListTrialsData>) => infiniteQueryOptions<ListTrialsResponse, AxiosError<DefaultError>, InfiniteData<ListTrialsResponse>, QueryKey<Options<ListTrialsData>>, number | Pick<QueryKey<Options<ListTrialsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListTrialsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTrials({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTrialsInfiniteQueryKey(options)
});

/**
 * Create a new trial within an organization.
 */
export const createTrialMutation = (options?: Partial<Options<CreateTrialData>>): UseMutationOptions<CreateTrialResponse, AxiosError<DefaultError>, Options<CreateTrialData>> => {
    const mutationOptions: UseMutationOptions<CreateTrialResponse, AxiosError<DefaultError>, Options<CreateTrialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTrial({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Smart delete a participant. System admin only.
 *
 * Uses resource state to determine strategy:
 * - **Delete**: Hard-delete if no enrollment or assignments.
 * - **Archive**: Soft-delete if has enrollment or active assignments.
 * - **Blocked**: Error if already archived.
 */
export const deleteParticipantMutation = (options?: Partial<Options<DeleteParticipantData>>): UseMutationOptions<DeleteParticipantResponse, AxiosError<DefaultError>, Options<DeleteParticipantData>> => {
    const mutationOptions: UseMutationOptions<DeleteParticipantResponse, AxiosError<DefaultError>, Options<DeleteParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getParticipantQueryKey = (options: Options<GetParticipantData>) => createQueryKey('getParticipant', options);

/**
 * Get a participant by ID.
 */
export const getParticipantOptions = (options: Options<GetParticipantData>) => queryOptions<GetParticipantResponse, AxiosError<DefaultError>, GetParticipantResponse, ReturnType<typeof getParticipantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParticipant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParticipantQueryKey(options)
});

/**
 * Update a participant.
 *
 * If `cohort_id` or `site_id` changes, verifies the new value belongs to the same trial.
 * If `participant_id` changes, validates format and uniqueness within the target cohort.
 */
export const updateParticipantMutation = (options?: Partial<Options<UpdateParticipantData>>): UseMutationOptions<UpdateParticipantResponse, AxiosError<DefaultError>, Options<UpdateParticipantData>> => {
    const mutationOptions: UseMutationOptions<UpdateParticipantResponse, AxiosError<DefaultError>, Options<UpdateParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getParticipantAdherenceQueryKey = (options: Options<GetParticipantAdherenceData>) => createQueryKey('getParticipantAdherence', options);

/**
 * Get participant medication adherence data.
 *
 * Returns adherence data with daily breakdowns, data quality flags,
 * bottle events, and quality events for the specified date range.
 */
export const getParticipantAdherenceOptions = (options: Options<GetParticipantAdherenceData>) => queryOptions<GetParticipantAdherenceResponse, AxiosError<DefaultError>, GetParticipantAdherenceResponse, ReturnType<typeof getParticipantAdherenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParticipantAdherence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParticipantAdherenceQueryKey(options)
});

/**
 * Complete an enrollment — mark as `COMPLETED` and deactivate assignments.
 *
 * Requires system admin. Returns 409 if already terminal.
 */
export const completeEnrollmentMutation = (options?: Partial<Options<CompleteEnrollmentData>>): UseMutationOptions<CompleteEnrollmentResponse, AxiosError<DefaultError>, Options<CompleteEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<CompleteEnrollmentResponse, AxiosError<DefaultError>, Options<CompleteEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send a push notification to a single participant.
 */
export const sendParticipantPushMutation = (options?: Partial<Options<SendParticipantPushData>>): UseMutationOptions<SendParticipantPushResponse, AxiosError<DefaultError>, Options<SendParticipantPushData>> => {
    const mutationOptions: UseMutationOptions<SendParticipantPushResponse, AxiosError<DefaultError>, Options<SendParticipantPushData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendParticipantPush({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset a single participant's enrollment data. **Staging/development only.**
 *
 * Deletes the participant's enrollments, dispenser assignments, the dispensers
 * they used, and all derived events/telemetry, while preserving the participant,
 * their medication slots, cohort, site, and trial config. Lets the participant
 * re-enroll from scratch and frees their dispenser serials for reuse.
 *
 * This route is not mounted in production; the handler also rejects production
 * as a backstop.
 */
export const resetParticipantEnrollmentMutation = (options?: Partial<Options<ResetParticipantEnrollmentData>>): UseMutationOptions<ResetParticipantEnrollmentResponse, AxiosError<DefaultError>, Options<ResetParticipantEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<ResetParticipantEnrollmentResponse, AxiosError<DefaultError>, Options<ResetParticipantEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetParticipantEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unarchive (restore) an archived participant. System admin only.
 */
export const unarchiveParticipantMutation = (options?: Partial<Options<UnarchiveParticipantData>>): UseMutationOptions<UnarchiveParticipantResponse, AxiosError<DefaultError>, Options<UnarchiveParticipantData>> => {
    const mutationOptions: UseMutationOptions<UnarchiveParticipantResponse, AxiosError<DefaultError>, Options<UnarchiveParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unarchiveParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Withdraw an enrollment — mark as `WITHDRAWN` and deactivate assignments.
 *
 * Requires system admin. Returns 409 if already terminal.
 */
export const withdrawEnrollmentMutation = (options?: Partial<Options<WithdrawEnrollmentData>>): UseMutationOptions<WithdrawEnrollmentResponse, AxiosError<DefaultError>, Options<WithdrawEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<WithdrawEnrollmentResponse, AxiosError<DefaultError>, Options<WithdrawEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await withdrawEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke permissions from a user (admin only).
 *
 * Revokes one or more permissions in bulk. Permissions that do not exist
 * are silently ignored.
 */
export const revokePermissionsMutation = (options?: Partial<Options<RevokePermissionsData>>): UseMutationOptions<RevokePermissionsResponse, AxiosError<DefaultError>, Options<RevokePermissionsData>> => {
    const mutationOptions: UseMutationOptions<RevokePermissionsResponse, AxiosError<DefaultError>, Options<RevokePermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokePermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPermissionsQueryKey = (options?: Options<ListPermissionsData>) => createQueryKey('listPermissions', options);

/**
 * List all permissions (paginated, admin only).
 *
 * Returns a paginated list of all permission records in the system.
 */
export const listPermissionsOptions = (options?: Options<ListPermissionsData>) => queryOptions<ListPermissionsResponse, AxiosError<DefaultError>, ListPermissionsResponse, ReturnType<typeof listPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPermissionsQueryKey(options)
});

export const listPermissionsInfiniteQueryKey = (options?: Options<ListPermissionsData>): QueryKey<Options<ListPermissionsData>> => createQueryKey('listPermissions', options, true);

/**
 * List all permissions (paginated, admin only).
 *
 * Returns a paginated list of all permission records in the system.
 */
export const listPermissionsInfiniteOptions = (options?: Options<ListPermissionsData>) => infiniteQueryOptions<ListPermissionsResponse, AxiosError<DefaultError>, InfiniteData<ListPermissionsResponse>, QueryKey<Options<ListPermissionsData>>, number | Pick<QueryKey<Options<ListPermissionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListPermissionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPermissions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPermissionsInfiniteQueryKey(options)
});

/**
 * Grant permissions to a user (admin only).
 *
 * Grants one or more permissions in bulk. Permissions that already exist
 * are skipped and reported in the `already_exists` field.
 */
export const grantPermissionsMutation = (options?: Partial<Options<GrantPermissionsData>>): UseMutationOptions<GrantPermissionsResponse, AxiosError<DefaultError>, Options<GrantPermissionsData>> => {
    const mutationOptions: UseMutationOptions<GrantPermissionsResponse, AxiosError<DefaultError>, Options<GrantPermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check a user's permissions (admin only).
 *
 * Checks one or more permission checks for a user and returns
 * whether each is allowed.
 */
export const checkPermissionsMutation = (options?: Partial<Options<CheckPermissionsData>>): UseMutationOptions<CheckPermissionsResponse, AxiosError<DefaultError>, Options<CheckPermissionsData>> => {
    const mutationOptions: UseMutationOptions<CheckPermissionsResponse, AxiosError<DefaultError>, Options<CheckPermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserPermissionsQueryKey = (options: Options<GetUserPermissionsData>) => createQueryKey('getUserPermissions', options);

/**
 * Get a user's permission summary (admin only).
 *
 * Returns all permissions for a specific user plus whether they are a system admin.
 */
export const getUserPermissionsOptions = (options: Options<GetUserPermissionsData>) => queryOptions<GetUserPermissionsResponse, AxiosError<DefaultError>, GetUserPermissionsResponse, ReturnType<typeof getUserPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserPermissionsQueryKey(options)
});

export const getAccessibleResourcesQueryKey = (options: Options<GetAccessibleResourcesData>) => createQueryKey('getAccessibleResources', options);

/**
 * Get accessible resources for a user (admin only).
 *
 * Returns all resource IDs a user can access for a given resource type.
 */
export const getAccessibleResourcesOptions = (options: Options<GetAccessibleResourcesData>) => queryOptions<GetAccessibleResourcesResponse, AxiosError<DefaultError>, GetAccessibleResourcesResponse, ReturnType<typeof getAccessibleResourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccessibleResources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccessibleResourcesQueryKey(options)
});

export const verifyTokenQueryKey = (options: Options<VerifyTokenData>) => createQueryKey('verifyToken', options);

/**
 * Exchange an email verification token for an access JWT.
 *
 * Decodes the 24-hour email verification JWT, looks up the submission,
 * and issues a 1-hour access token for form editing.
 */
export const verifyTokenOptions = (options: Options<VerifyTokenData>) => queryOptions<VerifyTokenResponse2, AxiosError<DefaultError>, VerifyTokenResponse2, ReturnType<typeof verifyTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await verifyToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: verifyTokenQueryKey(options)
});

export const getSubmissionQueryKey = (options: Options<GetSubmissionData>) => createQueryKey('getSubmission', options);

/**
 * Get public submission info by public token.
 *
 * Returns basic submission details. If a valid access JWT is provided
 * in the Authorization header, the response includes full form data and
 * timestamps. Without authentication, form data is empty and a guidance
 * message is included.
 */
export const getSubmissionOptions = (options: Options<GetSubmissionData>) => queryOptions<GetSubmissionResponse, AxiosError<DefaultError>, GetSubmissionResponse, ReturnType<typeof getSubmissionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSubmission({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSubmissionQueryKey(options)
});

/**
 * Autosave form data for a submission.
 *
 * Requires a valid access JWT from the verify-token endpoint. Only
 * submissions in draft or rejected status can be autosaved.
 */
export const autosaveMutation = (options?: Partial<Options<AutosaveData>>): UseMutationOptions<AutosaveResponse, AxiosError<DefaultError>, Options<AutosaveData>> => {
    const mutationOptions: UseMutationOptions<AutosaveResponse, AxiosError<DefaultError>, Options<AutosaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await autosave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request email verification for a submission.
 *
 * If the email is in the submission's allowed list, sends a verification
 * email with a 24-hour JWT link. Always returns success to prevent
 * email enumeration.
 */
export const requestVerificationMutation = (options?: Partial<Options<RequestVerificationData>>): UseMutationOptions<RequestVerificationResponse, AxiosError<DefaultError>, Options<RequestVerificationData>> => {
    const mutationOptions: UseMutationOptions<RequestVerificationResponse, AxiosError<DefaultError>, Options<RequestVerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestVerification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a trial setup form for review.
 *
 * Requires a valid access JWT. Validates form completeness (trial name,
 * at least one cohort, at least one site), saves form data, and transitions
 * the submission to "submitted" status.
 */
export const submitMutation = (options?: Partial<Options<SubmitData>>): UseMutationOptions<SubmitResponse, AxiosError<DefaultError>, Options<SubmitData>> => {
    const mutationOptions: UseMutationOptions<SubmitResponse, AxiosError<DefaultError>, Options<SubmitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unarchive (restore) an archived site.
 *
 * Requires system admin permission. Checks parent trial is not archived.
 */
export const unarchiveSiteMutation = (options?: Partial<Options<UnarchiveSiteData>>): UseMutationOptions<UnarchiveSiteResponse, AxiosError<DefaultError>, Options<UnarchiveSiteData>> => {
    const mutationOptions: UseMutationOptions<UnarchiveSiteResponse, AxiosError<DefaultError>, Options<UnarchiveSiteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unarchiveSite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTrialBySlugQueryKey = (options: Options<GetTrialBySlugData>) => createQueryKey('getTrialBySlug', options);

/**
 * Get a trial by slug.
 */
export const getTrialBySlugOptions = (options: Options<GetTrialBySlugData>) => queryOptions<GetTrialBySlugResponse, AxiosError<DefaultError>, GetTrialBySlugResponse, ReturnType<typeof getTrialBySlugQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTrialBySlug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTrialBySlugQueryKey(options)
});

export const getByTrialAndSerialQueryKey = (options: Options<GetByTrialAndSerialData>) => createQueryKey('getByTrialAndSerial', options);

/**
 * Get dispenser by trial slug and serial number.
 *
 * Looks up the trial by slug, finds the dispenser by serial number, and verifies
 * the dispenser has an active assignment to a participant enrolled in that trial.
 */
export const getByTrialAndSerialOptions = (options: Options<GetByTrialAndSerialData>) => queryOptions<GetByTrialAndSerialResponse, AxiosError<DefaultError>, GetByTrialAndSerialResponse, ReturnType<typeof getByTrialAndSerialQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getByTrialAndSerial({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getByTrialAndSerialQueryKey(options)
});

export const getParticipantBySlugQueryKey = (options: Options<GetParticipantBySlugData>) => createQueryKey('getParticipantBySlug', options);

/**
 * Get participant by trial slug and human-readable participant ID.
 *
 * Looks up the trial by slug, then finds the participant by its display
 * `participant_id` field (e.g. "P001"), **not** the UUID.
 */
export const getParticipantBySlugOptions = (options: Options<GetParticipantBySlugData>) => queryOptions<GetParticipantBySlugResponse, AxiosError<DefaultError>, GetParticipantBySlugResponse, ReturnType<typeof getParticipantBySlugQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParticipantBySlug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParticipantBySlugQueryKey(options)
});

/**
 * Smart delete a trial.
 *
 * Calculates deletion strategy based on resource state:
 * - **No active participants** → hard delete (permanent removal)
 * - **Has active participants** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteTrialMutation = (options?: Partial<Options<DeleteTrialData>>): UseMutationOptions<DeleteTrialResponse, AxiosError<DefaultError>, Options<DeleteTrialData>> => {
    const mutationOptions: UseMutationOptions<DeleteTrialResponse, AxiosError<DefaultError>, Options<DeleteTrialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTrial({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTrialQueryKey = (options: Options<GetTrialData>) => createQueryKey('getTrial', options);

/**
 * Get a trial by ID.
 */
export const getTrialOptions = (options: Options<GetTrialData>) => queryOptions<GetTrialResponse, AxiosError<DefaultError>, GetTrialResponse, ReturnType<typeof getTrialQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTrial({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTrialQueryKey(options)
});

/**
 * Update a trial (PUT — full replacement of provided fields).
 */
export const updateTrialMutation = (options?: Partial<Options<UpdateTrialData>>): UseMutationOptions<UpdateTrialResponse, AxiosError<DefaultError>, Options<UpdateTrialData>> => {
    const mutationOptions: UseMutationOptions<UpdateTrialResponse, AxiosError<DefaultError>, Options<UpdateTrialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTrial({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset all enrollment data for a trial. **Staging/development only.**
 *
 * Deletes enrollments, dispenser assignments, the dispensers they used, and all
 * derived events/telemetry, while preserving participants, cohorts, sites,
 * medication requirements, and slots. Lets a trial be re-enrolled from scratch
 * and frees its dispenser serials for reuse (the dispenser→participant lock is
 * enforced through assignment history).
 *
 * This route is not mounted in production; the handler also rejects production
 * as a backstop.
 */
export const resetTrialEnrollmentMutation = (options?: Partial<Options<ResetTrialEnrollmentData>>): UseMutationOptions<ResetTrialEnrollmentResponse, AxiosError<DefaultError>, Options<ResetTrialEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<ResetTrialEnrollmentResponse, AxiosError<DefaultError>, Options<ResetTrialEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetTrialEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change trial operational status. System admin only.
 *
 * Only accepts `ACTIVE` or `ARCHIVED` as valid target statuses.
 */
export const changeTrialStatusMutation = (options?: Partial<Options<ChangeTrialStatusData>>): UseMutationOptions<ChangeTrialStatusResponse, AxiosError<DefaultError>, Options<ChangeTrialStatusData>> => {
    const mutationOptions: UseMutationOptions<ChangeTrialStatusResponse, AxiosError<DefaultError>, Options<ChangeTrialStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeTrialStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unarchive a trial. System admin only.
 *
 * Checks that the parent organization is not archived before restoring.
 */
export const unarchiveTrialMutation = (options?: Partial<Options<UnarchiveTrialData>>): UseMutationOptions<UnarchiveTrialResponse, AxiosError<DefaultError>, Options<UnarchiveTrialData>> => {
    const mutationOptions: UseMutationOptions<UnarchiveTrialResponse, AxiosError<DefaultError>, Options<UnarchiveTrialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unarchiveTrial({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPopulationAdherenceQueryKey = (options: Options<GetPopulationAdherenceData>) => createQueryKey('getPopulationAdherence', options);

/**
 * Get population adherence for a trial.
 *
 * Returns aggregated adherence data across all participants in a trial,
 * with optional filtering by cohort/site, grouping, sorting, and pagination.
 */
export const getPopulationAdherenceOptions = (options: Options<GetPopulationAdherenceData>) => queryOptions<GetPopulationAdherenceResponse, AxiosError<DefaultError>, GetPopulationAdherenceResponse, ReturnType<typeof getPopulationAdherenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPopulationAdherence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPopulationAdherenceQueryKey(options)
});

export const getPopulationAdherenceInfiniteQueryKey = (options: Options<GetPopulationAdherenceData>): QueryKey<Options<GetPopulationAdherenceData>> => createQueryKey('getPopulationAdherence', options, true);

/**
 * Get population adherence for a trial.
 *
 * Returns aggregated adherence data across all participants in a trial,
 * with optional filtering by cohort/site, grouping, sorting, and pagination.
 */
export const getPopulationAdherenceInfiniteOptions = (options: Options<GetPopulationAdherenceData>) => infiniteQueryOptions<GetPopulationAdherenceResponse, AxiosError<DefaultError>, InfiniteData<GetPopulationAdherenceResponse>, QueryKey<Options<GetPopulationAdherenceData>>, number | null | Pick<QueryKey<Options<GetPopulationAdherenceData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetPopulationAdherenceData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPopulationAdherence({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPopulationAdherenceInfiniteQueryKey(options)
});

export const listCohortsQueryKey = (options: Options<ListCohortsData>) => createQueryKey('listCohorts', options);

/**
 * List cohorts for a trial (paginated).
 *
 * Returns cohorts with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listCohortsOptions = (options: Options<ListCohortsData>) => queryOptions<ListCohortsResponse, AxiosError<DefaultError>, ListCohortsResponse, ReturnType<typeof listCohortsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCohorts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCohortsQueryKey(options)
});

export const listCohortsInfiniteQueryKey = (options: Options<ListCohortsData>): QueryKey<Options<ListCohortsData>> => createQueryKey('listCohorts', options, true);

/**
 * List cohorts for a trial (paginated).
 *
 * Returns cohorts with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listCohortsInfiniteOptions = (options: Options<ListCohortsData>) => infiniteQueryOptions<ListCohortsResponse, AxiosError<DefaultError>, InfiniteData<ListCohortsResponse>, QueryKey<Options<ListCohortsData>>, number | Pick<QueryKey<Options<ListCohortsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListCohortsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listCohorts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCohortsInfiniteQueryKey(options)
});

/**
 * Create a new cohort within a trial.
 *
 * Slug is auto-generated from the cohort name. Name must be unique within the trial.
 * Parent trial must not be archived.
 */
export const createCohortMutation = (options?: Partial<Options<CreateCohortData>>): UseMutationOptions<CreateCohortResponse, AxiosError<DefaultError>, Options<CreateCohortData>> => {
    const mutationOptions: UseMutationOptions<CreateCohortResponse, AxiosError<DefaultError>, Options<CreateCohortData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCohort({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMedicationsQueryKey = (options: Options<ListMedicationsData>) => createQueryKey('listMedications', options);

/**
 * List medication requirements for a cohort (paginated).
 *
 * Returns medications with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listMedicationsOptions = (options: Options<ListMedicationsData>) => queryOptions<ListMedicationsResponse, AxiosError<DefaultError>, ListMedicationsResponse, ReturnType<typeof listMedicationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMedications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMedicationsQueryKey(options)
});

export const listMedicationsInfiniteQueryKey = (options: Options<ListMedicationsData>): QueryKey<Options<ListMedicationsData>> => createQueryKey('listMedications', options, true);

/**
 * List medication requirements for a cohort (paginated).
 *
 * Returns medications with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listMedicationsInfiniteOptions = (options: Options<ListMedicationsData>) => infiniteQueryOptions<ListMedicationsResponse, AxiosError<DefaultError>, InfiniteData<ListMedicationsResponse>, QueryKey<Options<ListMedicationsData>>, number | Pick<QueryKey<Options<ListMedicationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListMedicationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listMedications({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMedicationsInfiniteQueryKey(options)
});

/**
 * Create a new medication requirement within a cohort.
 *
 * The `dose_mg` is provided as a string and parsed to a decimal value.
 * Parent cohort and trial must not be archived.
 */
export const createMedicationMutation = (options?: Partial<Options<CreateMedicationData>>): UseMutationOptions<CreateMedicationResponse, AxiosError<DefaultError>, Options<CreateMedicationData>> => {
    const mutationOptions: UseMutationOptions<CreateMedicationResponse, AxiosError<DefaultError>, Options<CreateMedicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMedication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Nested DELETE: `/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}`
 */
export const deleteMedicationNestedMutation = (options?: Partial<Options<DeleteMedicationNestedData>>): UseMutationOptions<DeleteMedicationNestedResponse, AxiosError<DefaultError>, Options<DeleteMedicationNestedData>> => {
    const mutationOptions: UseMutationOptions<DeleteMedicationNestedResponse, AxiosError<DefaultError>, Options<DeleteMedicationNestedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMedicationNested({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMedicationNestedQueryKey = (options: Options<GetMedicationNestedData>) => createQueryKey('getMedicationNested', options);

/**
 * Nested GET: `/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}`
 */
export const getMedicationNestedOptions = (options: Options<GetMedicationNestedData>) => queryOptions<GetMedicationNestedResponse, AxiosError<DefaultError>, GetMedicationNestedResponse, ReturnType<typeof getMedicationNestedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMedicationNested({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMedicationNestedQueryKey(options)
});

/**
 * Nested PUT: `/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}`
 */
export const updateMedicationNestedMutation = (options?: Partial<Options<UpdateMedicationNestedData>>): UseMutationOptions<UpdateMedicationNestedResponse, AxiosError<DefaultError>, Options<UpdateMedicationNestedData>> => {
    const mutationOptions: UseMutationOptions<UpdateMedicationNestedResponse, AxiosError<DefaultError>, Options<UpdateMedicationNestedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMedicationNested({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listContactsQueryKey = (options: Options<ListContactsData>) => createQueryKey('listContacts', options);

/**
 * List contacts for a trial.
 */
export const listContactsOptions = (options: Options<ListContactsData>) => queryOptions<ListContactsResponse, AxiosError<DefaultError>, ListContactsResponse, ReturnType<typeof listContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContactsQueryKey(options)
});

export const listContactsInfiniteQueryKey = (options: Options<ListContactsData>): QueryKey<Options<ListContactsData>> => createQueryKey('listContacts', options, true);

/**
 * List contacts for a trial.
 */
export const listContactsInfiniteOptions = (options: Options<ListContactsData>) => infiniteQueryOptions<ListContactsResponse, AxiosError<DefaultError>, InfiniteData<ListContactsResponse>, QueryKey<Options<ListContactsData>>, number | Pick<QueryKey<Options<ListContactsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContactsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContacts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContactsInfiniteQueryKey(options)
});

/**
 * Create a new contact for a trial.
 */
export const createContactMutation = (options?: Partial<Options<CreateContactData>>): UseMutationOptions<CreateContactResponse, AxiosError<DefaultError>, Options<CreateContactData>> => {
    const mutationOptions: UseMutationOptions<CreateContactResponse, AxiosError<DefaultError>, Options<CreateContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a trial contact.
 */
export const deleteContactMutation = (options?: Partial<Options<DeleteContactData>>): UseMutationOptions<DeleteContactResponse, AxiosError<DefaultError>, Options<DeleteContactData>> => {
    const mutationOptions: UseMutationOptions<DeleteContactResponse, AxiosError<DefaultError>, Options<DeleteContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a trial contact.
 */
export const updateContactMutation = (options?: Partial<Options<UpdateContactData>>): UseMutationOptions<UpdateContactResponse, AxiosError<DefaultError>, Options<UpdateContactData>> => {
    const mutationOptions: UseMutationOptions<UpdateContactResponse, AxiosError<DefaultError>, Options<UpdateContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDeliveriesQueryKey = (options: Options<ListDeliveriesData>) => createQueryKey('listDeliveries', options);

/**
 * List notification deliveries for a trial.
 */
export const listDeliveriesOptions = (options: Options<ListDeliveriesData>) => queryOptions<ListDeliveriesResponse, AxiosError<DefaultError>, ListDeliveriesResponse, ReturnType<typeof listDeliveriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDeliveries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDeliveriesQueryKey(options)
});

export const listDeliveriesInfiniteQueryKey = (options: Options<ListDeliveriesData>): QueryKey<Options<ListDeliveriesData>> => createQueryKey('listDeliveries', options, true);

/**
 * List notification deliveries for a trial.
 */
export const listDeliveriesInfiniteOptions = (options: Options<ListDeliveriesData>) => infiniteQueryOptions<ListDeliveriesResponse, AxiosError<DefaultError>, InfiniteData<ListDeliveriesResponse>, QueryKey<Options<ListDeliveriesData>>, number | Pick<QueryKey<Options<ListDeliveriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDeliveriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDeliveries({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDeliveriesInfiniteQueryKey(options)
});

/**
 * Export notification deliveries as CSV or JSON.
 */
export const exportDeliveriesMutation = (options?: Partial<Options<ExportDeliveriesData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ExportDeliveriesData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ExportDeliveriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportDeliveries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeliveryQueryKey = (options: Options<GetDeliveryData>) => createQueryKey('getDelivery', options);

/**
 * Get a single notification delivery.
 */
export const getDeliveryOptions = (options: Options<GetDeliveryData>) => queryOptions<GetDeliveryResponse, AxiosError<DefaultError>, GetDeliveryResponse, ReturnType<typeof getDeliveryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDelivery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeliveryQueryKey(options)
});

export const listDeliveryAttachmentsQueryKey = (options: Options<ListDeliveryAttachmentsData>) => createQueryKey('listDeliveryAttachments', options);

/**
 * List attachments for a delivery (metadata only, no binary content).
 */
export const listDeliveryAttachmentsOptions = (options: Options<ListDeliveryAttachmentsData>) => queryOptions<ListDeliveryAttachmentsResponse, AxiosError<DefaultError>, ListDeliveryAttachmentsResponse, ReturnType<typeof listDeliveryAttachmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDeliveryAttachments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDeliveryAttachmentsQueryKey(options)
});

export const downloadAttachmentQueryKey = (options: Options<DownloadAttachmentData>) => createQueryKey('downloadAttachment', options);

/**
 * Download a delivery attachment.
 */
export const downloadAttachmentOptions = (options: Options<DownloadAttachmentData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof downloadAttachmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadAttachment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadAttachmentQueryKey(options)
});

export const getDeliveryContentQueryKey = (options: Options<GetDeliveryContentData>) => createQueryKey('getDeliveryContent', options);

/**
 * Get the rendered HTML content of a delivery.
 *
 * Returns the archived email body as `text/html`.
 */
export const getDeliveryContentOptions = (options: Options<GetDeliveryContentData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getDeliveryContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeliveryContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeliveryContentQueryKey(options)
});

export const deviceHealthSummaryQueryKey = (options: Options<DeviceHealthSummaryData>) => createQueryKey('deviceHealthSummary', options);

/**
 * Get device health summary counts for a trial.
 */
export const deviceHealthSummaryOptions = (options: Options<DeviceHealthSummaryData>) => queryOptions<DeviceHealthSummaryResponse2, AxiosError<DefaultError>, DeviceHealthSummaryResponse2, ReturnType<typeof deviceHealthSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deviceHealthSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deviceHealthSummaryQueryKey(options)
});

export const listEventsQueryKey = (options: Options<ListEventsData>) => createQueryKey('listEvents', options);

/**
 * List notification events for a trial.
 */
export const listEventsOptions = (options: Options<ListEventsData>) => queryOptions<ListEventsResponse, AxiosError<DefaultError>, ListEventsResponse, ReturnType<typeof listEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEventsQueryKey(options)
});

export const listEventsInfiniteQueryKey = (options: Options<ListEventsData>): QueryKey<Options<ListEventsData>> => createQueryKey('listEvents', options, true);

/**
 * List notification events for a trial.
 */
export const listEventsInfiniteOptions = (options: Options<ListEventsData>) => infiniteQueryOptions<ListEventsResponse, AxiosError<DefaultError>, InfiniteData<ListEventsResponse>, QueryKey<Options<ListEventsData>>, number | Pick<QueryKey<Options<ListEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listEvents({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEventsInfiniteQueryKey(options)
});

/**
 * Bulk acknowledge multiple events.
 */
export const bulkAcknowledgeMutation = (options?: Partial<Options<BulkAcknowledgeData>>): UseMutationOptions<BulkAcknowledgeResponse2, AxiosError<DefaultError>, Options<BulkAcknowledgeData>> => {
    const mutationOptions: UseMutationOptions<BulkAcknowledgeResponse2, AxiosError<DefaultError>, Options<BulkAcknowledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkAcknowledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEventSummaryQueryKey = (options: Options<GetEventSummaryData>) => createQueryKey('getEventSummary', options);

/**
 * Get event summary (counts by status, type, severity).
 */
export const getEventSummaryOptions = (options: Options<GetEventSummaryData>) => queryOptions<GetEventSummaryResponse, AxiosError<DefaultError>, GetEventSummaryResponse, ReturnType<typeof getEventSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventSummaryQueryKey(options)
});

export const getEventQueryKey = (options: Options<GetEventData>) => createQueryKey('getEvent', options);

/**
 * Get a single notification event.
 */
export const getEventOptions = (options: Options<GetEventData>) => queryOptions<GetEventResponse, AxiosError<DefaultError>, GetEventResponse, ReturnType<typeof getEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventQueryKey(options)
});

/**
 * Acknowledge a notification event.
 */
export const acknowledgeEventMutation = (options?: Partial<Options<AcknowledgeEventData>>): UseMutationOptions<AcknowledgeEventResponse, AxiosError<DefaultError>, Options<AcknowledgeEventData>> => {
    const mutationOptions: UseMutationOptions<AcknowledgeEventResponse, AxiosError<DefaultError>, Options<AcknowledgeEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acknowledgeEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve a notification event.
 */
export const resolveEventMutation = (options?: Partial<Options<ResolveEventData>>): UseMutationOptions<ResolveEventResponse, AxiosError<DefaultError>, Options<ResolveEventData>> => {
    const mutationOptions: UseMutationOptions<ResolveEventResponse, AxiosError<DefaultError>, Options<ResolveEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTrialLiveFeedQueryKey = (options: Options<GetTrialLiveFeedData>) => createQueryKey('getTrialLiveFeed', options);

export const getTrialLiveFeedOptions = (options: Options<GetTrialLiveFeedData>) => queryOptions<GetTrialLiveFeedResponse, AxiosError<DefaultError>, GetTrialLiveFeedResponse, ReturnType<typeof getTrialLiveFeedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTrialLiveFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTrialLiveFeedQueryKey(options)
});

export const listProfilesQueryKey = (options: Options<ListProfilesData>) => createQueryKey('listProfiles', options);

/**
 * List notification profiles for a trial.
 */
export const listProfilesOptions = (options: Options<ListProfilesData>) => queryOptions<ListProfilesResponse, AxiosError<DefaultError>, ListProfilesResponse, ReturnType<typeof listProfilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProfiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProfilesQueryKey(options)
});

export const listProfilesInfiniteQueryKey = (options: Options<ListProfilesData>): QueryKey<Options<ListProfilesData>> => createQueryKey('listProfiles', options, true);

/**
 * List notification profiles for a trial.
 */
export const listProfilesInfiniteOptions = (options: Options<ListProfilesData>) => infiniteQueryOptions<ListProfilesResponse, AxiosError<DefaultError>, InfiniteData<ListProfilesResponse>, QueryKey<Options<ListProfilesData>>, number | Pick<QueryKey<Options<ListProfilesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListProfilesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listProfiles({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProfilesInfiniteQueryKey(options)
});

/**
 * Create a custom notification profile.
 */
export const createProfileMutation = (options?: Partial<Options<CreateProfileData>>): UseMutationOptions<CreateProfileResponse, AxiosError<DefaultError>, Options<CreateProfileData>> => {
    const mutationOptions: UseMutationOptions<CreateProfileResponse, AxiosError<DefaultError>, Options<CreateProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a custom notification profile.
 */
export const deleteProfileMutation = (options?: Partial<Options<DeleteProfileData>>): UseMutationOptions<DeleteProfileResponse, AxiosError<DefaultError>, Options<DeleteProfileData>> => {
    const mutationOptions: UseMutationOptions<DeleteProfileResponse, AxiosError<DefaultError>, Options<DeleteProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProfile2QueryKey = (options: Options<GetProfile2Data>) => createQueryKey('getProfile2', options);

/**
 * Get a single notification profile.
 */
export const getProfile2Options = (options: Options<GetProfile2Data>) => queryOptions<GetProfile2Response, AxiosError<DefaultError>, GetProfile2Response, ReturnType<typeof getProfile2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProfile2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProfile2QueryKey(options)
});

/**
 * Update a notification profile.
 */
export const updateProfileMutation = (options?: Partial<Options<UpdateProfileData>>): UseMutationOptions<UpdateProfileResponse, AxiosError<DefaultError>, Options<UpdateProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateProfileResponse, AxiosError<DefaultError>, Options<UpdateProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview a notification profile's email output.
 *
 * Returns one preview per distinct cadence in the profile's subscriptions,
 * populated with sample data so the user can see a realistic email.
 */
export const previewProfileMutation = (options?: Partial<Options<PreviewProfileData>>): UseMutationOptions<PreviewProfileResponse, AxiosError<DefaultError>, Options<PreviewProfileData>> => {
    const mutationOptions: UseMutationOptions<PreviewProfileResponse, AxiosError<DefaultError>, Options<PreviewProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send a test email for a notification profile.
 *
 * Renders the same preview content and actually delivers it to the
 * specified email address. The delivery is logged with `notification_type = "test"`.
 */
export const testSendProfileMutation = (options?: Partial<Options<TestSendProfileData>>): UseMutationOptions<TestSendProfileResponse, AxiosError<DefaultError>, Options<TestSendProfileData>> => {
    const mutationOptions: UseMutationOptions<TestSendProfileResponse, AxiosError<DefaultError>, Options<TestSendProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testSendProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSettingsQueryKey = (options: Options<GetSettingsData>) => createQueryKey('getSettings', options);

/**
 * Get notification settings for a trial (returns defaults if no row exists).
 */
export const getSettingsOptions = (options: Options<GetSettingsData>) => queryOptions<GetSettingsResponse, AxiosError<DefaultError>, GetSettingsResponse, ReturnType<typeof getSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSettingsQueryKey(options)
});

/**
 * Upsert notification settings for a trial.
 */
export const upsertSettingsMutation = (options?: Partial<Options<UpsertSettingsData>>): UseMutationOptions<UpsertSettingsResponse, AxiosError<DefaultError>, Options<UpsertSettingsData>> => {
    const mutationOptions: UseMutationOptions<UpsertSettingsResponse, AxiosError<DefaultError>, Options<UpsertSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listParticipantsQueryKey = (options: Options<ListParticipantsData>) => createQueryKey('listParticipants', options);

/**
 * List participants for a trial (paginated).
 *
 * Returns participants with pagination, sorting, and search.
 * Participants belong to cohorts which belong to trials, so this
 * filters by finding cohorts for the trial first.
 * Supports additional filters: `cohort_id`, `site_id`.
 */
export const listParticipantsOptions = (options: Options<ListParticipantsData>) => queryOptions<ListParticipantsResponse, AxiosError<DefaultError>, ListParticipantsResponse, ReturnType<typeof listParticipantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listParticipants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listParticipantsQueryKey(options)
});

export const listParticipantsInfiniteQueryKey = (options: Options<ListParticipantsData>): QueryKey<Options<ListParticipantsData>> => createQueryKey('listParticipants', options, true);

/**
 * List participants for a trial (paginated).
 *
 * Returns participants with pagination, sorting, and search.
 * Participants belong to cohorts which belong to trials, so this
 * filters by finding cohorts for the trial first.
 * Supports additional filters: `cohort_id`, `site_id`.
 */
export const listParticipantsInfiniteOptions = (options: Options<ListParticipantsData>) => infiniteQueryOptions<ListParticipantsResponse, AxiosError<DefaultError>, InfiniteData<ListParticipantsResponse>, QueryKey<Options<ListParticipantsData>>, number | Pick<QueryKey<Options<ListParticipantsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListParticipantsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listParticipants({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listParticipantsInfiniteQueryKey(options)
});

/**
 * Create a new participant within a trial.
 *
 * The enrollment token is auto-generated. The cohort and site must both
 * belong to the specified trial.
 */
export const createParticipantMutation = (options?: Partial<Options<CreateParticipantData>>): UseMutationOptions<CreateParticipantResponse, AxiosError<DefaultError>, Options<CreateParticipantData>> => {
    const mutationOptions: UseMutationOptions<CreateParticipantResponse, AxiosError<DefaultError>, Options<CreateParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk import participants into a trial.
 *
 * Validates all participants first. If `dry_run` is true, returns what would
 * happen without inserting. If false, inserts valid participants and skips
 * duplicates.
 */
export const bulkImportParticipantsMutation = (options?: Partial<Options<BulkImportParticipantsData>>): UseMutationOptions<BulkImportParticipantsResponse, AxiosError<DefaultError>, Options<BulkImportParticipantsData>> => {
    const mutationOptions: UseMutationOptions<BulkImportParticipantsResponse, AxiosError<DefaultError>, Options<BulkImportParticipantsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkImportParticipants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate enrollment forms for participants.
 *
 * Generates enrollment forms as PDF or JSON and returns the file directly.
 */
export const generateEnrollmentFormsMutation = (options?: Partial<Options<GenerateEnrollmentFormsData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<GenerateEnrollmentFormsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<GenerateEnrollmentFormsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateEnrollmentForms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Nested DELETE: `/trials/{trial_id}/participants/{participant_id}`
 */
export const deleteTrialParticipantMutation = (options?: Partial<Options<DeleteTrialParticipantData>>): UseMutationOptions<DeleteTrialParticipantResponse, AxiosError<DefaultError>, Options<DeleteTrialParticipantData>> => {
    const mutationOptions: UseMutationOptions<DeleteTrialParticipantResponse, AxiosError<DefaultError>, Options<DeleteTrialParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTrialParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTrialParticipantQueryKey = (options: Options<GetTrialParticipantData>) => createQueryKey('getTrialParticipant', options);

/**
 * Get a participant within a trial context.
 *
 * Verifies the participant belongs to the trial (via cohort) and returns
 * the participant with enriched trial context (trial name, cohort name).
 */
export const getTrialParticipantOptions = (options: Options<GetTrialParticipantData>) => queryOptions<GetTrialParticipantResponse, AxiosError<DefaultError>, GetTrialParticipantResponse, ReturnType<typeof getTrialParticipantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTrialParticipant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTrialParticipantQueryKey(options)
});

/**
 * Nested PUT: `/trials/{trial_id}/participants/{participant_id}`
 */
export const updateTrialParticipantMutation = (options?: Partial<Options<UpdateTrialParticipantData>>): UseMutationOptions<UpdateTrialParticipantResponse, AxiosError<DefaultError>, Options<UpdateTrialParticipantData>> => {
    const mutationOptions: UseMutationOptions<UpdateTrialParticipantResponse, AxiosError<DefaultError>, Options<UpdateTrialParticipantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTrialParticipant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEnrollmentQueryKey = (options: Options<GetEnrollmentData>) => createQueryKey('getEnrollment', options);

/**
 * Get enrollment status for a participant.
 *
 * Returns enrollment status, activation date, and masked token information.
 */
export const getEnrollmentOptions = (options: Options<GetEnrollmentData>) => queryOptions<GetEnrollmentResponse, AxiosError<DefaultError>, GetEnrollmentResponse, ReturnType<typeof getEnrollmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEnrollment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEnrollmentQueryKey(options)
});

export const getParticipantHealthQueryKey = (options: Options<GetParticipantHealthData>) => createQueryKey('getParticipantHealth', options);

/**
 * Get health summary for a participant across all assigned devices.
 */
export const getParticipantHealthOptions = (options: Options<GetParticipantHealthData>) => queryOptions<GetParticipantHealthResponse, AxiosError<DefaultError>, GetParticipantHealthResponse, ReturnType<typeof getParticipantHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParticipantHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParticipantHealthQueryKey(options)
});

export const getMedicationSlots2QueryKey = (options: Options<GetMedicationSlots2Data>) => createQueryKey('getMedicationSlots2', options);

/**
 * Get medication slots for a participant.
 *
 * Returns slot assignments with medication requirement details.
 */
export const getMedicationSlots2Options = (options: Options<GetMedicationSlots2Data>) => queryOptions<GetMedicationSlots2Response, AxiosError<DefaultError>, GetMedicationSlots2Response, ReturnType<typeof getMedicationSlots2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMedicationSlots2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMedicationSlots2QueryKey(options)
});

/**
 * Send push notifications to participants in a trial.
 */
export const pushSendMutation = (options?: Partial<Options<PushSendData>>): UseMutationOptions<PushSendResponse, AxiosError<DefaultError>, Options<PushSendData>> => {
    const mutationOptions: UseMutationOptions<PushSendResponse, AxiosError<DefaultError>, Options<PushSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pushSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPushStatusQueryKey = (options: Options<GetPushStatusData>) => createQueryKey('getPushStatus', options);

/**
 * Get push notification status for a trial.
 */
export const getPushStatusOptions = (options: Options<GetPushStatusData>) => queryOptions<GetPushStatusResponse, AxiosError<DefaultError>, GetPushStatusResponse, ReturnType<typeof getPushStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPushStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPushStatusQueryKey(options)
});

export const listSitesQueryKey = (options: Options<ListSitesData>) => createQueryKey('listSites', options);

/**
 * List all sites for a trial (paginated).
 *
 * Returns sites with pagination, sorting, and search.
 * Supports filtering by status: "active" (default), "archived", or "all".
 */
export const listSitesOptions = (options: Options<ListSitesData>) => queryOptions<ListSitesResponse, AxiosError<DefaultError>, ListSitesResponse, ReturnType<typeof listSitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSitesQueryKey(options)
});

export const listSitesInfiniteQueryKey = (options: Options<ListSitesData>): QueryKey<Options<ListSitesData>> => createQueryKey('listSites', options, true);

/**
 * List all sites for a trial (paginated).
 *
 * Returns sites with pagination, sorting, and search.
 * Supports filtering by status: "active" (default), "archived", or "all".
 */
export const listSitesInfiniteOptions = (options: Options<ListSitesData>) => infiniteQueryOptions<ListSitesResponse, AxiosError<DefaultError>, InfiniteData<ListSitesResponse>, QueryKey<Options<ListSitesData>>, number | Pick<QueryKey<Options<ListSitesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSitesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSites({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSitesInfiniteQueryKey(options)
});

/**
 * Create a new site within a trial.
 *
 * Slug is auto-generated from the site name. Parent trial must not be archived.
 */
export const createSiteMutation = (options?: Partial<Options<CreateSiteData>>): UseMutationOptions<CreateSiteResponse, AxiosError<DefaultError>, Options<CreateSiteData>> => {
    const mutationOptions: UseMutationOptions<CreateSiteResponse, AxiosError<DefaultError>, Options<CreateSiteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Smart delete a site.
 *
 * Calculates deletion strategy based on resource state:
 * - **No participants** → hard delete (permanent removal)
 * - **Has participants** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteSiteMutation = (options?: Partial<Options<DeleteSiteData>>): UseMutationOptions<DeleteSiteResponse, AxiosError<DefaultError>, Options<DeleteSiteData>> => {
    const mutationOptions: UseMutationOptions<DeleteSiteResponse, AxiosError<DefaultError>, Options<DeleteSiteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSiteQueryKey = (options: Options<GetSiteData>) => createQueryKey('getSite', options);

/**
 * Get a site by ID.
 *
 * Verifies the site belongs to the specified trial.
 */
export const getSiteOptions = (options: Options<GetSiteData>) => queryOptions<GetSiteResponse, AxiosError<DefaultError>, GetSiteResponse, ReturnType<typeof getSiteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSiteQueryKey(options)
});

/**
 * Update a site (PUT).
 *
 * When the name changes, the slug is regenerated automatically.
 * Parent trial must not be archived.
 */
export const updateSiteMutation = (options?: Partial<Options<UpdateSiteData>>): UseMutationOptions<UpdateSiteResponse, AxiosError<DefaultError>, Options<UpdateSiteData>> => {
    const mutationOptions: UseMutationOptions<UpdateSiteResponse, AxiosError<DefaultError>, Options<UpdateSiteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send a study message to participants via push notification.
 *
 * Creates a study message record and sends push notifications to
 * targeted participants. The message appears in the app's message
 * inbox (routed via `data.type = "study_message"`).
 */
export const sendStudyMessageMutation = (options?: Partial<Options<SendStudyMessageData>>): UseMutationOptions<SendStudyMessageResponse2, AxiosError<DefaultError>, Options<SendStudyMessageData>> => {
    const mutationOptions: UseMutationOptions<SendStudyMessageResponse2, AxiosError<DefaultError>, Options<SendStudyMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendStudyMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the current user's profile.
 *
 * Allows updating name and/or email. Email must be unique across all users.
 */
export const updateProfile2Mutation = (options?: Partial<Options<UpdateProfile2Data>>): UseMutationOptions<UpdateProfile2Response, AxiosError<DefaultError>, Options<UpdateProfile2Data>> => {
    const mutationOptions: UseMutationOptions<UpdateProfile2Response, AxiosError<DefaultError>, Options<UpdateProfile2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProfile2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disable two-factor authentication.
 *
 * Requires a valid TOTP code for security verification before disabling.
 */
export const disable2FaMutation = (options?: Partial<Options<Disable2FaData>>): UseMutationOptions<Disable2FaResponse, AxiosError<DefaultError>, Options<Disable2FaData>> => {
    const mutationOptions: UseMutationOptions<Disable2FaResponse, AxiosError<DefaultError>, Options<Disable2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disable2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable two-factor authentication.
 *
 * Requires a valid TOTP code from the authenticator app to confirm
 * the secret was correctly set up.
 */
export const enable2FaMutation = (options?: Partial<Options<Enable2FaData>>): UseMutationOptions<Enable2FaResponse, AxiosError<DefaultError>, Options<Enable2FaData>> => {
    const mutationOptions: UseMutationOptions<Enable2FaResponse, AxiosError<DefaultError>, Options<Enable2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enable2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate a TOTP secret for 2FA setup.
 *
 * Returns the secret and a provisioning URI for QR code generation.
 * The secret is stored but 2FA is not enabled until confirmed with
 * `POST /2fa/enable`.
 */
export const generate2FaMutation = (options?: Partial<Options<Generate2FaData>>): UseMutationOptions<Generate2FaResponse, AxiosError<DefaultError>, Options<Generate2FaData>> => {
    const mutationOptions: UseMutationOptions<Generate2FaResponse, AxiosError<DefaultError>, Options<Generate2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generate2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyAccessibleResourcesQueryKey = (options: Options<GetMyAccessibleResourcesData>) => createQueryKey('getMyAccessibleResources', options);

/**
 * Get the current user's accessible resources for a given type.
 *
 * Returns all resource IDs the authenticated user has permissions on
 * for the requested resource type.
 */
export const getMyAccessibleResourcesOptions = (options: Options<GetMyAccessibleResourcesData>) => queryOptions<GetMyAccessibleResourcesResponse, AxiosError<DefaultError>, GetMyAccessibleResourcesResponse, ReturnType<typeof getMyAccessibleResourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyAccessibleResources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyAccessibleResourcesQueryKey(options)
});

export const listPasskeysQueryKey = (options?: Options<ListPasskeysData>) => createQueryKey('listPasskeys', options);

/**
 * List the current user's registered passkeys.
 */
export const listPasskeysOptions = (options?: Options<ListPasskeysData>) => queryOptions<ListPasskeysResponse, AxiosError<DefaultError>, ListPasskeysResponse, ReturnType<typeof listPasskeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPasskeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPasskeysQueryKey(options)
});

/**
 * Complete passkey registration.
 *
 * Verifies the credential response and stores the passkey in the database.
 */
export const registerFinishMutation = (options?: Partial<Options<RegisterFinishData>>): UseMutationOptions<RegisterFinishResponse, AxiosError<DefaultError>, Options<RegisterFinishData>> => {
    const mutationOptions: UseMutationOptions<RegisterFinishResponse, AxiosError<DefaultError>, Options<RegisterFinishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerFinish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start passkey registration.
 *
 * Returns `WebAuthn` creation options that the browser passes to
 * `navigator.credentials.create()`. Challenge state is stored in the cache.
 */
export const registerStartMutation = (options?: Partial<Options<RegisterStartData>>): UseMutationOptions<RegisterStartResponse2, AxiosError<DefaultError>, Options<RegisterStartData>> => {
    const mutationOptions: UseMutationOptions<RegisterStartResponse2, AxiosError<DefaultError>, Options<RegisterStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a registered passkey.
 */
export const deletePasskeyMutation = (options?: Partial<Options<DeletePasskeyData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeletePasskeyData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeletePasskeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePasskey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change the current user's password.
 *
 * Requires the current password for verification. The new password must
 * meet strength requirements (uppercase, lowercase, digit, special character).
 */
export const changePasswordMutation = (options?: Partial<Options<ChangePasswordData>>): UseMutationOptions<ChangePasswordResponse, AxiosError<DefaultError>, Options<ChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<ChangePasswordResponse, AxiosError<DefaultError>, Options<ChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyPermissionsQueryKey = (options?: Options<GetMyPermissionsData>) => createQueryKey('getMyPermissions', options);

/**
 * Get the current user's permission summary.
 *
 * Returns all direct and inherited permissions for the authenticated user.
 */
export const getMyPermissionsOptions = (options?: Options<GetMyPermissionsData>) => queryOptions<GetMyPermissionsResponse, AxiosError<DefaultError>, GetMyPermissionsResponse, ReturnType<typeof getMyPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyPermissionsQueryKey(options)
});

/**
 * Check multiple permissions for the current user.
 *
 * Returns whether each requested permission is granted and the source
 * of the grant (system admin, direct grant, or inherited from parent).
 */
export const checkMyPermissionsMutation = (options?: Partial<Options<CheckMyPermissionsData>>): UseMutationOptions<CheckMyPermissionsResponse, AxiosError<DefaultError>, Options<CheckMyPermissionsData>> => {
    const mutationOptions: UseMutationOptions<CheckMyPermissionsResponse, AxiosError<DefaultError>, Options<CheckMyPermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkMyPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
